import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "4072249e-bada-40ff-ba9e-64dab281acbc"
// title: "Polytopia 2025 Presenters"
// type: :html
// key: "polytopia-2025-presenters"
// parent_id: nil
export function Polytopia2025Presenters4072249eBada40ffBa9e64dab281acbc(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia2025Presenters4072249eBada40ffBa9e64dab281acbc page gf-page-layout page gf-page-layout`}>
      {props["header"] || <ContentItem className="HeaderDb3480c82b184a72A97153bc1e0e6dbc" parentTag={buildClassName("HeaderDb3480c82b184a72A97153bc1e0e6dbc", parentTag)} contentSlug="polytopia-2025-presenters-header-with-hero" subType="header_with_hero" as="header" className="public-header-with-hero secondary-page" {...props} />}
      <main>
        {props["intro"] || <ContentSnippet className="Intro7a7f29c6Eef74734Add6Bf3f38e05bb4" parentTag={buildClassName("Intro7a7f29c6Eef74734Add6Bf3f38e05bb4", parentTag)} className="intro-text" contentSlug="polytopia-2025-presenters-intro-text" {...props} />}
        {props["cards"] || <MarketingCards className="CardsE8860531Bb884c11A4917dd232f7a31d" parentTag={buildClassName("CardsE8860531Bb884c11A4917dd232f7a31d", parentTag)} postSlug="polytopia-2025-presenters-cards" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="FooterA34c7552D66b4944914dDe47e744e4ec" {...props} />}
    </div>
  );
}

// id: "c9e3ffb4-4ecf-4540-a2cb-858ba2782ba4"
// title: "Polytopia 2024"
// type: :html
// key: "polytopia-2024"
// parent_id: nil
export function Polytopia2024C9e3ffb44ecf4540A2cb858ba2782ba4(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia2024C9e3ffb44ecf4540A2cb858ba2782ba4 page gf-page-layout page gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeaderD322727b39004ea6956f5716c320962c parentTag="Header6c19d6800f0b4753B047B5e66481f1a5" title="Polytopia 2024" {...props} />}
      <main>
        {props["body"] || <MarketingCardsEc2efbf9428e4f188793C61ac4b78538 parentTag="BodyB1468b7f33b040ccB62346b3a0a0ae03" postSlug="polytopia-2024" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="Footer7ffb809a7101464c824a154022dddf77" {...props} />}
    </div>
  );
}

// id: "7ee34b54-5872-4ca7-9dba-3aecfdd5e711"
// title: "Polytopia 2026 Sponsors"
// type: :html
// key: "polytopia-2026-sponsors"
// parent_id: nil
export function Polytopia2026Sponsors7ee34b5458724ca79dba3aecfdd5e711(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia2026Sponsors7ee34b5458724ca79dba3aecfdd5e711 page gf-page-layout page gf-page-layout`}>
      {props["header"] || <ContentItem className="HeaderFba5956aBe28463dB0b29af03b3977c3" parentTag={buildClassName("HeaderFba5956aBe28463dB0b29af03b3977c3", parentTag)} className="public-header-with-hero secondary-page" as="header" subType="header_with_hero" contentSlug="polytopia-2025-sponsors-header-with-hero" {...props} />}
      <main>
        {props["intro"] || <ContentSnippet className="IntroAc342f728ff74f6aB99a8e91c952cd4c" parentTag={buildClassName("IntroAc342f728ff74f6aB99a8e91c952cd4c", parentTag)} contentSlug="polytopia-2026-sponsors-intro" {...props} />}
        {props["cards"] || <MarketingCards className="CardsD16ea53d52d146b5A684252e41a4cfbc" parentTag={buildClassName("CardsD16ea53d52d146b5A684252e41a4cfbc", parentTag)} postSlug="polytopia-2026-sponsors-cards" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="FooterEaec2e20589a45afAbd8F0daa9d67c56" {...props} />}
    </div>
  );
}

// id: "422edffb-989f-4c33-82c7-f6696a97485e"
// title: ""
// type: :reference
// key: "marketingCards"
// parent_id: "3e8d1d1a-cf55-4de8-979d-33d4b536ae88"
export function MarketingCards422edffb989f4c3382c7F6696a97485e(props: any) {
  return (
    <MarketingCardsEc2efbf9428e4f188793C61ac4b78538 parentTag="MarketingCards422edffb989f4c3382c7F6696a97485e" postSlug="home-page-posts2" {...props} />
  );
}

// id: "f6fe8d74-f65f-4c91-8fb5-647ca4489db6"
// title: ""
// type: :gf_preset
// key: "social-links"
// parent_id: "431498e3-a11c-4d75-9a7b-b4c9f9cf7c75"
export function SocialLinksF6fe8d74F65f4c918fb5647ca4489db6(props: any) {
  const SocialLinks = AppStore.presets["SocialLinks"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <SocialLinks className="SocialLinksF6fe8d74F65f4c918fb5647ca4489db6" parentTag={buildClassName("SocialLinksF6fe8d74F65f4c918fb5647ca4489db6", parentTag)} postSlug="footer-social-links" {...props} />
  );
}

// id: "fd7c4072-d8dd-4f3b-a0cc-3c69d210a332"
// title: "Footer Clone xRXtkVcbB7vf9dR Clone I9XQT7FHAZPJGAC15 Clone YBYEQWBTJ7M1RURES Clone 9QERD06Z1IRV6P2WO Clone RA2IOSI5WU9MZT94L Clone YUVGVZYF1SFIDD5MB"
// type: :reference
// key: "footer"
// parent_id: "08dd2a7c-03af-4d94-b901-fbe2d2af471a"
export function FooterFd7c4072D8dd4f3bA0cc3c69d210a332(props: any) {
  return (
    <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="FooterFd7c4072D8dd4f3bA0cc3c69d210a332" {...props} />
  );
}

// id: "e37101d1-725f-44f1-8ab8-8c6d18d413f0"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "c0ec48a7-2bbf-4996-b185-b0e8f64f97cb"
export function HeaderTopE37101d1725f44f18ab88c6d18d413f0(props: any) {
  return (
    <DefaultHeaderTopB5b2de7c36d94c739f44306fa937c712 parentTag="HeaderTopE37101d1725f44f18ab88c6d18d413f0" {...props} />
  );
}

// id: "15352273-88af-40c0-b184-6eff6debaf9b"
// title: ""
// type: :reference
// key: "header"
// parent_id: "301b0b82-8030-4324-a772-e738b349e1b2"
export function Header1535227388af40c0B1846eff6debaf9b(props: any) {
  return (
    <MembersAreaHeader897ce2cbAcaf4349B1463421534478b4 parentTag="Header1535227388af40c0B1846eff6debaf9b" {...props} />
  );
}

// id: "b8d6d8f8-1d31-410c-9c70-2159a72b26a7"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "cb7df874-0390-43e8-98bc-667dba362100"
export const ContentSlugB8d6d8f81d31410c9c702159a72b26a7 = "polytopia-2026-presenters-intro-text";

// id: "73f01a4e-7152-42d3-be15-c95068c476e5"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "db3480c8-2b18-4a72-a971-53bc1e0e6dbc"
export const ContentSlug73f01a4e715242d3Be15C95068c476e5 = "polytopia-2025-presenters-header-with-hero";

// id: "6e174bb6-5bb6-4bfa-9b00-b813513d272c"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "810aebb7-d028-4348-93bf-aebf4f399b2b"
export const NavMenuSlug6e174bb65bb64bfa9b00B813513d272c = "members-primary-nav";

// id: "dea14d61-9dba-4df2-88c3-362ce5228ed2"
// title: ""
// type: :text
// key: "as"
// parent_id: "4f87b07d-15f5-443c-88f9-ca828939ffbd"
export const AsDea14d619dba4df288c3362ce5228ed2 = "header";

// id: "3fdce8c8-3e27-4d1e-9688-6c49c59e3fd8"
// title: ""
// type: :text
// key: "as"
// parent_id: "75aa199d-900b-4636-941d-3703ca282a4e"
export const As3fdce8c83e274d1e96886c49c59e3fd8 = "header";

// id: "0778c503-4dd8-405a-ae8a-b3a43795e736"
// title: "Members Header"
// type: :reference
// key: "header"
// parent_id: nil
export function Header0778c5034dd8405aAe8aB3a43795e736(props: any) {
  return (
    <MembersAreaHeader897ce2cbAcaf4349B1463421534478b4 parentTag="Header0778c5034dd8405aAe8aB3a43795e736" {...props} />
  );
}

// id: "c0ec48a7-2bbf-4996-b185-b0e8f64f97cb"
// title: "Home Header"
// type: :html
// key: "home-header"
// parent_id: nil
export function HomeHeaderC0ec48a72bbf4996B185B0e8f64f97cb(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomeHeaderC0ec48a72bbf4996B185B0e8f64f97cb site-header`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopB5b2de7c36d94c739f44306fa937c712 parentTag="HeaderTopE37101d1725f44f18ab88c6d18d413f0" {...props} />}
      </div>
      {props["hero"] || <Hero className="Hero9679a72e69744fd0816a5a192e535f09" parentTag={buildClassName("Hero9679a72e69744fd0816a5a192e535f09", parentTag)} postSlug="home-hero" {...props} />}
    </div>
  );
}

// id: "b316e28e-cae6-45b3-9781-7b1775114d9e"
// title: "Page Quote"
// type: :html
// key: "page-quote"
// parent_id: nil
export function PageQuoteB316e28eCae645b397817b1775114d9e(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PageQuoteB316e28eCae645b397817b1775114d9e`}>
      <div>
      </div>
      <div>
      </div>
    </div>
  );
}

// id: "5fb41566-cf34-457e-93cf-5bf05232c71d"
// title: ""
// type: :gf_preset
// key: "sponsors"
// parent_id: "2394baa1-cb1e-48d3-ab02-c8c97332f98c"
export function Sponsors5fb41566Cf34457e93cf5bf05232c71d(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="Sponsors5fb41566Cf34457e93cf5bf05232c71d" parentTag={buildClassName("Sponsors5fb41566Cf34457e93cf5bf05232c71d", parentTag)} contentSlug="polytopia-2026-sponsors" {...props} />
  );
}

// id: "05732d95-2d13-4764-8335-e543c068dc94"
// title: ""
// type: :gf_preset
// key: "cards"
// parent_id: "2394baa1-cb1e-48d3-ab02-c8c97332f98c"
export function Cards05732d952d1347648335E543c068dc94(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="Cards05732d952d1347648335E543c068dc94" parentTag={buildClassName("Cards05732d952d1347648335E543c068dc94", parentTag)} postSlug="polytopia-2026-cards" {...props} />
  );
}

// id: "fba5956a-be28-463d-b0b2-9af03b3977c3"
// title: "Header"
// type: :gf_preset
// key: "header"
// parent_id: "7ee34b54-5872-4ca7-9dba-3aecfdd5e711"
export function HeaderFba5956aBe28463dB0b29af03b3977c3(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="HeaderFba5956aBe28463dB0b29af03b3977c3" parentTag={buildClassName("HeaderFba5956aBe28463dB0b29af03b3977c3", parentTag)} className="public-header-with-hero secondary-page" as="header" subType="header_with_hero" contentSlug="polytopia-2025-sponsors-header-with-hero" {...props} />
  );
}

// id: "80cd575d-5a52-415c-8bc8-96422cda80f6"
// title: ""
// type: :gf_preset
// key: "sponsors"
// parent_id: "1ac7c8ab-0c03-4635-ae90-9d9ceefc0042"
export function Sponsors80cd575d5a52415c8bc896422cda80f6(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="Sponsors80cd575d5a52415c8bc896422cda80f6" parentTag={buildClassName("Sponsors80cd575d5a52415c8bc896422cda80f6", parentTag)} {...props} />
  );
}

// id: "260af353-3019-4597-a742-693edbb1568b"
// title: ""
// type: :text
// key: "backgroundImage"
// parent_id: "98ce7e4a-8f24-4b36-91da-2cf0511fd380"
export const BackgroundImage260af35330194597A742693edbb1568b = "https://mp1md-pub.s3.amazonaws.com/orgs/sample/city-background.jpg";

// id: "b086f85f-751a-43f2-9182-8426b89806bc"
// title: ""
// type: :text
// key: "as"
// parent_id: "4a4fc60b-b4a3-4a0d-b72a-6f0ebf6adeb8"
export const AsB086f85f751a43f291828426b89806bc = "header";

// id: "0002a459-6145-4110-b874-38ae66d623ac"
// title: ""
// type: :text
// key: "className"
// parent_id: "83c68578-7525-4f90-b6c8-b16b2b98cae5"
export const ClassName0002a45961454110B87438ae66d623ac = "public-header-with-hero secondary-page";

// id: "2492ae59-7ccd-4232-a9ea-8bfdcb65db85"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "83c68578-7525-4f90-b6c8-b16b2b98cae5"
export const ContentSlug2492ae597ccd4232A9ea8bfdcb65db85 = "polytopia-2025-workshops-header-with-hero";

// id: "88e3fe84-ba74-432a-a03a-4ce7016d24e7"
// title: ""
// type: :text
// key: "subType"
// parent_id: "db3480c8-2b18-4a72-a971-53bc1e0e6dbc"
export const SubType88e3fe84Ba74432aA03a4ce7016d24e7 = "header_with_hero";

// id: "b8c7e564-13c7-4d1b-942d-34844512af78"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "74ede452-646b-4403-902d-0233072c00c9"
export const ContentSlugB8c7e56413c74d1b942d34844512af78 = "polytopia-2025-schedule-main";

// id: "f1695465-f9cb-43fb-bd34-0a8711450b63"
// title: "Polytopia 2025 Workshops"
// type: :html
// key: "polytopia-2025-workshops"
// parent_id: nil
export function Polytopia2025WorkshopsF1695465F9cb43fbBd340a8711450b63(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia2025WorkshopsF1695465F9cb43fbBd340a8711450b63 page gf-page-layout page gf-page-layout`}>
      {props["header"] || <ContentItem className="Header83c6857875254f90B6c8B16b2b98cae5" parentTag={buildClassName("Header83c6857875254f90B6c8B16b2b98cae5", parentTag)} className="public-header-with-hero secondary-page" contentSlug="polytopia-2025-workshops-header-with-hero" as="header" subType="header_with_hero" {...props} />}
      <main>
        {props["main-content"] || <PageContentSimplified className="MainContent231083a591cc4c388d31B416c279df65" parentTag={buildClassName("MainContent231083a591cc4c388d31B416c279df65", parentTag)} contentSlug="polytopia-2025-workshops-content" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="Footer2046e99e13574c8dA26d65ac045077c2" {...props} />}
    </div>
  );
}

// id: "8d915476-22b7-45e1-941d-6e130611248d"
// title: "Message Pages"
// type: :html
// key: "message-pages"
// parent_id: nil
export function MessagePages8d91547622b745e1941d6e130611248d(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MessagePages8d91547622b745e1941d6e130611248d gf-page-layout`}>
      {props["header"] || <MembersAreaHeader897ce2cbAcaf4349B1463421534478b4 parentTag="HeaderB746f40bAc47431f982194a21f80ed31" {...props} />}
      {props.children}
    </div>
  );
}

// id: "d8882c31-fe23-4687-a469-4b937d8f0f1d"
// title: "Title - Leveling"
// type: :text
// key: "title"
// parent_id: nil
export const TitleD8882c31Fe234687A4694b937d8f0f1d = "Leveling";

// id: "d3d54706-6220-4367-a242-75c2d034aa53"
// title: "Footer Clone xRXtkVcbB7vf9dR Clone I9XQT7FHAZPJGAC15 Clone YBYEQWBTJ7M1RURES Clone 9QERD06Z1IRV6P2WO Clone RA2IOSI5WU9MZT94L Clone X60TRD0XRW2DZ77ZB Clone 0XGEAUIWHNJ3APNRS"
// type: :reference
// key: "footer"
// parent_id: "df950adf-456f-4805-97ba-0f1198c81e87"
export function FooterD3d5470662204367A24275c2d034aa53(props: any) {
  return (
    <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="FooterD3d5470662204367A24275c2d034aa53" {...props} />
  );
}

// id: "4b8343b6-b273-4bd1-b916-9407681e74bb"
// title: ""
// type: :gf_preset
// key: "main-content"
// parent_id: "df950adf-456f-4805-97ba-0f1198c81e87"
export function MainContent4b8343b6B2734bd1B9169407681e74bb(props: any) {
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageContentSimplified className="MainContent4b8343b6B2734bd1B9169407681e74bb" parentTag={buildClassName("MainContent4b8343b6B2734bd1B9169407681e74bb", parentTag)} contentSlug="polytopia-2026-handouts-main" {...props} />
  );
}

// id: "231083a5-91cc-4c38-8d31-b416c279df65"
// title: ""
// type: :gf_preset
// key: "main-content"
// parent_id: "f1695465-f9cb-43fb-bd34-0a8711450b63"
export function MainContent231083a591cc4c388d31B416c279df65(props: any) {
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageContentSimplified className="MainContent231083a591cc4c388d31B416c279df65" parentTag={buildClassName("MainContent231083a591cc4c388d31B416c279df65", parentTag)} contentSlug="polytopia-2025-workshops-content" {...props} />
  );
}

// id: "d47b2dc2-2cd9-4de8-a63a-62555e588dc0"
// title: ""
// type: :gf_preset
// key: "cards"
// parent_id: "a1c5efd5-78e1-4cbb-9a6c-abc7c6676c62"
export function CardsD47b2dc22cd94de8A63a62555e588dc0(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="CardsD47b2dc22cd94de8A63a62555e588dc0" parentTag={buildClassName("CardsD47b2dc22cd94de8A63a62555e588dc0", parentTag)} postSlug="polytopia-2026-presenters-cards" {...props} />
  );
}

// id: "6730e02c-a933-471c-ada3-37da8e10554c"
// title: "Header Clone SiJc8owDIOQgqYh"
// type: :gf_preset
// key: "header"
// parent_id: "3908d6b2-1d25-46f6-a831-1708917b7a92"
export function Header6730e02cA933471cAda337da8e10554c(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header6730e02cA933471cAda337da8e10554c" parentTag={buildClassName("Header6730e02cA933471cAda337da8e10554c", parentTag)} title="Polytopia 2025" contentSlug="polytopia-2025-header-with-hero" className="public-header-with-hero secondary-page" as="header" subType="header_with_hero" {...props} />
  );
}

// id: "597a7f6e-07f9-4494-8176-66617be36482"
// title: ""
// type: :text
// key: "as"
// parent_id: "de7e30e6-26d6-45d9-ad10-d66fcdeadb79"
export const As597a7f6e07f94494817666617be36482 = "header";

// id: "d3b893b7-3d49-48c8-abec-eb5e7d17e14c"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "a40ccb8f-1e17-48fa-bfa5-7fef9a770c87"
export const PostSlugD3b893b73d4948c8AbecEb5e7d17e14c = "polytopia-2025-sponsors";

// id: "4f3d7145-6f04-47ad-be93-111574ee9c43"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "17d37437-0c97-49aa-9240-77f93b574aee"
export const ContentSlug4f3d71456f0447adBe93111574ee9c43 = "polytopia-page-sponsors";

// id: "8c1822f2-52c2-4ea9-94cd-fc07f33e8439"
// title: ""
// type: :text
// key: "subType"
// parent_id: "e673878b-6a82-4da4-9fc3-02b393bb9158"
export const SubType8c1822f252c24ea994cdFc07f33e8439 = "header_with_hero";

// id: "c5fe79fe-a7bb-4c5f-9bf8-71c87a2d0092"
// title: ""
// type: :text
// key: "class"
// parent_id: "4f34f9d5-d9e0-4c75-9677-ec0acd91bf48"
export const ClassC5fe79feA7bb4c5f9bf871c87a2d0092 = "linked-logo";

// id: "897ce2cb-acaf-4349-b146-3421534478b4"
// title: "Members Area Header"
// type: :reference
// key: "members-area-header"
// parent_id: nil
export function MembersAreaHeader897ce2cbAcaf4349B1463421534478b4(props: any) {
  return (
    <ShortHeader98ce7e4a8f244b3691da2cf0511fd380 parentTag="MembersAreaHeader897ce2cbAcaf4349B1463421534478b4" header-top={<DefaultHeaderTopB5b2de7c36d94c739f44306fa937c712 parentTag="HeaderTopFd1f85b6Eb5f4f9aA5f6B50feee66ee1" navMenuSlug="members-primary-nav" />} {...props} />
  );
}

// id: "a1c5efd5-78e1-4cbb-9a6c-abc7c6676c62"
// title: "Polytopia 2026 Presenters"
// type: :html
// key: "polytopia-2026-presenters"
// parent_id: nil
export function Polytopia2026PresentersA1c5efd578e14cbb9a6cAbc7c6676c62(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia2026PresentersA1c5efd578e14cbb9a6cAbc7c6676c62 page gf-page-layout page gf-page-layout`}>
      {props["header"] || <ContentItem className="HeaderAa0f08e0346248b8BddbBf7a92150f9f" parentTag={buildClassName("HeaderAa0f08e0346248b8BddbBf7a92150f9f", parentTag)} contentSlug="polytopia-2026-presenters-header-with-hero" subType="header_with_hero" className="public-header-with-hero secondary-page" as="header" {...props} />}
      <main>
        {props["intro"] || <ContentSnippet className="IntroCb7df874039043e898bc667dba362100" parentTag={buildClassName("IntroCb7df874039043e898bc667dba362100", parentTag)} contentSlug="polytopia-2026-presenters-intro-text" className="intro-text" {...props} />}
        {props["cards"] || <MarketingCards className="CardsD47b2dc22cd94de8A63a62555e588dc0" parentTag={buildClassName("CardsD47b2dc22cd94de8A63a62555e588dc0", parentTag)} postSlug="polytopia-2026-presenters-cards" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="Footer6926554bFf714fa7A4000e350f433c1b" {...props} />}
    </div>
  );
}

// id: "431498e3-a11c-4d75-9a7b-b4c9f9cf7c75"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75(props: any) {
  const SocialLinks = AppStore.presets["SocialLinks"];
  const Navigation = AppStore.presets["Navigation"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 footer`}>
      {props["social-links"] || <SocialLinks className="SocialLinksF6fe8d74F65f4c918fb5647ca4489db6" parentTag={buildClassName("SocialLinksF6fe8d74F65f4c918fb5647ca4489db6", parentTag)} postSlug="footer-social-links" {...props} />}
      {props["links"] || <Navigation className="Links465a3355F94847c48642Cc65fe8ce945" parentTag={buildClassName("Links465a3355F94847c48642Cc65fe8ce945", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo34f631c1Cd42400dB02e98789a562436 />}
      </div>
      {props["copyright"] || <GroupCopyright className="Copyright07957308Ba0f4778839f3a2cf03fdb83" parentTag={buildClassName("Copyright07957308Ba0f4778839f3a2cf03fdb83", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow082a3554B4d74a31B87aAf8490a5ae71" parentTag={buildClassName("Groupflow082a3554B4d74a31B87aAf8490a5ae71", parentTag)} {...props} />}
    </footer>
  );
}

// id: "62fb7053-395b-4237-889b-db8fc7d03c35"
// title: ""
// type: :gf_preset
// key: "main-content"
// parent_id: "cc27fbec-3950-4476-9c33-61b66b58ff7b"
export function MainContent62fb7053395b4237889bDb8fc7d03c35(props: any) {
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageContentSimplified className="MainContent62fb7053395b4237889bDb8fc7d03c35" parentTag={buildClassName("MainContent62fb7053395b4237889bDb8fc7d03c35", parentTag)} contentSlug="polytopia-2026-workshops-content" {...props} />
  );
}

// id: "eaec2e20-589a-45af-abd8-f0daa9d67c56"
// title: "Footer Clone xRXtkVcbB7vf9dR Clone I9XQT7FHAZPJGAC15 Clone NE93G482WP5J87HE7"
// type: :reference
// key: "footer"
// parent_id: "7ee34b54-5872-4ca7-9dba-3aecfdd5e711"
export function FooterEaec2e20589a45afAbd8F0daa9d67c56(props: any) {
  return (
    <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="FooterEaec2e20589a45afAbd8F0daa9d67c56" {...props} />
  );
}

// id: "9aafe6f7-00df-4917-bba6-93421ba69b4f"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "64781529-d160-4d7e-a914-5a78296a449e"
export function Header9aafe6f700df4917Bba693421ba69b4f(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header9aafe6f700df4917Bba693421ba69b4f" parentTag={buildClassName("Header9aafe6f700df4917Bba693421ba69b4f", parentTag)} contentSlug="polytopia-2025-schedule-header-with-hero" subType="header_with_hero" as="header" className="public-header-with-hero secondary-page" {...props} />
  );
}

// id: "e17cdbc6-65c4-4412-84ad-ec551ebb4118"
// title: ""
// type: :gf_preset
// key: "main-content"
// parent_id: "08dd2a7c-03af-4d94-b901-fbe2d2af471a"
export function MainContentE17cdbc665c4441284adEc551ebb4118(props: any) {
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageContentSimplified className="MainContentE17cdbc665c4441284adEc551ebb4118" parentTag={buildClassName("MainContentE17cdbc665c4441284adEc551ebb4118", parentTag)} contentSlug="polytopia-2026-schedule-main" {...props} />
  );
}

// id: "e673878b-6a82-4da4-9fc3-02b393bb9158"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "1ac7c8ab-0c03-4635-ae90-9d9ceefc0042"
export function HeaderE673878b6a824da49fc302b393bb9158(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="HeaderE673878b6a824da49fc302b393bb9158" parentTag={buildClassName("HeaderE673878b6a824da49fc302b393bb9158", parentTag)} subType="header_with_hero" contentSlug="polytopia-2025-handouts-header-with-hero" className="public-header-with-hero secondary-page" as="header" {...props} />
  );
}

// id: "fe392684-1703-46c0-82ae-a410b62af7b6"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "aa0f08e0-3462-48b8-bddb-bf7a92150f9f"
export const ContentSlugFe392684170346c082aeA410b62af7b6 = "polytopia-2026-presenters-header-with-hero";

// id: "7ee487c2-b181-432a-b1d9-9dd6a3a3683e"
// title: ""
// type: :text
// key: "title"
// parent_id: "76cf718a-ec42-4c61-97bd-8f531c0c1998"
export const Title7ee487c2B181432aB1d99dd6a3a3683e = "About Us";

// id: "46e4e6c9-8ee0-40ff-9783-0e436386d363"
// title: ""
// type: :text
// key: "title"
// parent_id: "34d95305-57bf-4775-a8f2-3a3789f0732a"
export const Title46e4e6c98ee040ff97830e436386d363 = "Join Us";

// id: "3a350b6c-b435-4f6d-bcf0-9843dafe728b"
// title: ""
// type: :text
// key: "subType"
// parent_id: "92500507-4e60-4a1f-a91c-f77b1faaca57"
export const SubType3a350b6cB4354f6dBcf09843dafe728b = "header_with_hero";

// id: "2f741eb2-606b-4cba-a7d5-d5bca8539f07"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "51c25f57-a580-4388-ab19-8ddf316b636e"
export const PostSlug2f741eb2606b4cbaA7d5D5bca8539f07 = "polytopia-2025";

// id: "d322727b-3900-4ea6-956f-5716c320962c"
// title: "Secondary Marketing Header"
// type: :html
// key: "secondary-marketing-header"
// parent_id: nil
export function SecondaryMarketingHeaderD322727b39004ea6956f5716c320962c(props: any) {
  const { parentTag, ...rest } = props;
  props = { title: "Secondary Marketing Title 1", ...rest };
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeaderD322727b39004ea6956f5716c320962c site-header`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopB5b2de7c36d94c739f44306fa937c712 parentTag="HeaderTop89f653e94d454dcc893bFdb19b5ee8c2" {...props} />}
      </div>
      {props["hero"] || <SecondaryMarketingHero2a580a58Ae5b4c08A86eAa6b1313a1ff parentTag="Hero7e1ec0caB59d49bdBc29A9e6c20bc914" title="Secondary Marketing Title 2" {...props} />}
    </div>
  );
}

// id: "64781529-d160-4d7e-a914-5a78296a449e"
// title: "Polytopia 2025 Schedule"
// type: :html
// key: "polytopia-2025-schedule"
// parent_id: nil
export function Polytopia2025Schedule64781529D1604d7eA9145a78296a449e(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia2025Schedule64781529D1604d7eA9145a78296a449e page gf-page-layout page gf-page-layout`}>
      {props["header"] || <ContentItem className="Header9aafe6f700df4917Bba693421ba69b4f" parentTag={buildClassName("Header9aafe6f700df4917Bba693421ba69b4f", parentTag)} contentSlug="polytopia-2025-schedule-header-with-hero" subType="header_with_hero" as="header" className="public-header-with-hero secondary-page" {...props} />}
      <main>
        {props["main-content"] || <PageContentSimplified className="MainContent74ede452646b4403902d0233072c00c9" parentTag={buildClassName("MainContent74ede452646b4403902d0233072c00c9", parentTag)} contentSlug="polytopia-2025-schedule-main" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="Footer5db7db8aA4fe41ab8dd71356b3e13e7d" {...props} />}
    </div>
  );
}

// id: "60351a5d-8a40-48e4-993f-1c30e4e7cdc8"
// title: ""
// type: :gf_preset
// key: "main-content"
// parent_id: "1ac7c8ab-0c03-4635-ae90-9d9ceefc0042"
export function MainContent60351a5d8a4048e4993f1c30e4e7cdc8(props: any) {
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageContentSimplified className="MainContent60351a5d8a4048e4993f1c30e4e7cdc8" parentTag={buildClassName("MainContent60351a5d8a4048e4993f1c30e4e7cdc8", parentTag)} contentSlug="polytopia-2025-handouts-main" {...props} />
  );
}

// id: "7a7f29c6-eef7-4734-add6-bf3f38e05bb4"
// title: ""
// type: :gf_preset
// key: "intro"
// parent_id: "4072249e-bada-40ff-ba9e-64dab281acbc"
export function Intro7a7f29c6Eef74734Add6Bf3f38e05bb4(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="Intro7a7f29c6Eef74734Add6Bf3f38e05bb4" parentTag={buildClassName("Intro7a7f29c6Eef74734Add6Bf3f38e05bb4", parentTag)} className="intro-text" contentSlug="polytopia-2025-presenters-intro-text" {...props} />
  );
}

// id: "2046e99e-1357-4c8d-a26d-65ac045077c2"
// title: "Footer Clone xRXtkVcbB7vf9dR Clone I9XQT7FHAZPJGAC15 Clone YBYEQWBTJ7M1RURES Clone 9QERD06Z1IRV6P2WO"
// type: :reference
// key: "footer"
// parent_id: "f1695465-f9cb-43fb-bd34-0a8711450b63"
export function Footer2046e99e13574c8dA26d65ac045077c2(props: any) {
  return (
    <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="Footer2046e99e13574c8dA26d65ac045077c2" {...props} />
  );
}

// id: "b746f40b-ac47-431f-9821-94a21f80ed31"
// title: ""
// type: :reference
// key: "header"
// parent_id: "8d915476-22b7-45e1-941d-6e130611248d"
export function HeaderB746f40bAc47431f982194a21f80ed31(props: any) {
  return (
    <MembersAreaHeader897ce2cbAcaf4349B1463421534478b4 parentTag="HeaderB746f40bAc47431f982194a21f80ed31" {...props} />
  );
}

// id: "c70c6d7e-2030-44e5-96a3-0532c26798f1"
// title: ""
// type: :gf_preset
// key: "sponsors"
// parent_id: "4072249e-bada-40ff-ba9e-64dab281acbc"
export function SponsorsC70c6d7e203044e596a30532c26798f1(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="SponsorsC70c6d7e203044e596a30532c26798f1" parentTag={buildClassName("SponsorsC70c6d7e203044e596a30532c26798f1", parentTag)} {...props} />
  );
}

// id: "cb7df874-0390-43e8-98bc-667dba362100"
// title: ""
// type: :gf_preset
// key: "intro"
// parent_id: "a1c5efd5-78e1-4cbb-9a6c-abc7c6676c62"
export function IntroCb7df874039043e898bc667dba362100(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="IntroCb7df874039043e898bc667dba362100" parentTag={buildClassName("IntroCb7df874039043e898bc667dba362100", parentTag)} contentSlug="polytopia-2026-presenters-intro-text" className="intro-text" {...props} />
  );
}

// id: "e33f6747-1f5d-4bb3-88ae-fc0205a030b8"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "4f87b07d-15f5-443c-88f9-ca828939ffbd"
export const ContentSlugE33f67471f5d4bb388aeFc0205a030b8 = "polytopia-2026-sponsors-header-with-hero";

// id: "50edf15d-a00f-4e65-8df7-5d81925b338b"
// title: ""
// type: :text
// key: "title"
// parent_id: "8c9903d2-97f3-43a5-a727-b422ac9ffcae"
export const Title50edf15dA00f4e658df75d81925b338b = "Join Us";

// id: "0feddc69-aa11-4037-9752-e38f695a9099"
// title: ""
// type: :text
// key: "title"
// parent_id: "6730e02c-a933-471c-ada3-37da8e10554c"
export const Title0feddc69Aa1140379752E38f695a9099 = "Polytopia 2025";

// id: "cc2512a7-ccd2-45bc-b158-06931ba544f8"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "e673878b-6a82-4da4-9fc3-02b393bb9158"
export const ContentSlugCc2512a7Ccd245bcB15806931ba544f8 = "polytopia-2025-handouts-header-with-hero";

// id: "4f980093-8d16-4f5b-bc2d-f264992c9d6d"
// title: ""
// type: :text
// key: "class"
// parent_id: "326b96d8-b838-4e9e-9300-f8e5f7e44234"
export const Class4f9800938d164f5bBc2dF264992c9d6d = "navigation";

// id: "e9cede63-cd1f-4ab3-88e7-18a811b72970"
// title: "Signup Pages"
// type: :reference
// key: "signup-pages"
// parent_id: nil
export function SignupPagesE9cede63Cd1f4ab388e718a811b72970(props: any) {
  return (
    <SecondaryPageAba48207A5c34fdc96e43317026c1125 parentTag="SignupPagesE9cede63Cd1f4ab388e718a811b72970" header={<SecondaryMarketingHeaderD322727b39004ea6956f5716c320962c parentTag="Header8c9903d297f343a5A727B422ac9ffcae" title="Join Us" />} {...props} />
  );
}

// id: "b7f57dea-85d9-4fcb-a380-8e0616076d1a"
// title: "Levels 1-4 Explained"
// type: :html
// key: "about-leveling-page"
// parent_id: nil
export function AboutLevelingPageB7f57dea85d94fcbA3808e0616076d1a(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutLevelingPageB7f57dea85d94fcbA3808e0616076d1a gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeaderD322727b39004ea6956f5716c320962c parentTag="Header78400dd88d284c6bB15c32fb36211fa1" title="Leveling" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="Footer39ef6466A05a47579d9eD4ae7d92e7ab" {...props} />}
    </div>
  );
}

// id: "320bd74b-f1fa-4ee6-8553-1780be90146d"
// title: ""
// type: :gf_preset
// key: "sponsors"
// parent_id: "df950adf-456f-4805-97ba-0f1198c81e87"
export function Sponsors320bd74bF1fa4ee685531780be90146d(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="Sponsors320bd74bF1fa4ee685531780be90146d" parentTag={buildClassName("Sponsors320bd74bF1fa4ee685531780be90146d", parentTag)} {...props} />
  );
}

// id: "75aa199d-900b-4636-941d-3703ca282a4e"
// title: "Header Clone SiJc8owDIOQgqYh Clone F82SSDIS4SM8PPXZH"
// type: :gf_preset
// key: "header"
// parent_id: "8c3a11ae-70fb-4398-8569-42bcd6be18d1"
export function Header75aa199d900b4636941d3703ca282a4e(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header75aa199d900b4636941d3703ca282a4e" parentTag={buildClassName("Header75aa199d900b4636941d3703ca282a4e", parentTag)} as="header" className="public-header-with-hero secondary-page" subType="header_with_hero" contentSlug="polytopia-2025-sponsors-header-with-hero" {...props} />
  );
}

// id: "7270b350-3b92-48c9-a237-b2f720303d0e"
// title: ""
// type: :gf_preset
// key: "sponsors"
// parent_id: "64781529-d160-4d7e-a914-5a78296a449e"
export function Sponsors7270b3503b9248c9A237B2f720303d0e(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="Sponsors7270b3503b9248c9A237B2f720303d0e" parentTag={buildClassName("Sponsors7270b3503b9248c9A237B2f720303d0e", parentTag)} {...props} />
  );
}

// id: "6c19d680-0f0b-4753-b047-b5e66481f1a5"
// title: "Header"
// type: :reference
// key: "header"
// parent_id: "c9e3ffb4-4ecf-4540-a2cb-858ba2782ba4"
export function Header6c19d6800f0b4753B047B5e66481f1a5(props: any) {
  return (
    <SecondaryMarketingHeaderD322727b39004ea6956f5716c320962c parentTag="Header6c19d6800f0b4753B047B5e66481f1a5" title="Polytopia 2024" {...props} />
  );
}

// id: "17d37437-0c97-49aa-9240-77f93b574aee"
// title: ""
// type: :gf_preset
// key: "sponsors"
// parent_id: "3908d6b2-1d25-46f6-a831-1708917b7a92"
export function Sponsors17d374370c9749aa924077f93b574aee(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="Sponsors17d374370c9749aa924077f93b574aee" parentTag={buildClassName("Sponsors17d374370c9749aa924077f93b574aee", parentTag)} contentSlug="polytopia-page-sponsors" {...props} />
  );
}

// id: "fd20f010-a85b-4b95-8f46-5c1b4c8fa41c"
// title: "Footer Clone xRXtkVcbB7vf9dR Clone I9XQT7FHAZPJGAC15 Clone YBYEQWBTJ7M1RURES Clone 9QERD06Z1IRV6P2WO Clone FSRRZ624M1ZWVYIEM"
// type: :reference
// key: "footer"
// parent_id: "cc27fbec-3950-4476-9c33-61b66b58ff7b"
export function FooterFd20f010A85b4b958f465c1b4c8fa41c(props: any) {
  return (
    <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="FooterFd20f010A85b4b958f465c1b4c8fa41c" {...props} />
  );
}

// id: "15b9057d-0a44-4882-be54-c8620d2cbb2d"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "62fb7053-395b-4237-889b-db8fc7d03c35"
export const ContentSlug15b9057d0a444882Be54C8620d2cbb2d = "polytopia-2026-workshops-content";

// id: "a1dee271-a2a0-4725-9f66-512040262295"
// title: ""
// type: :text
// key: "title"
// parent_id: "25314445-a50b-4b9d-bf98-eeeba79428ab"
export const TitleA1dee271A2a047259f66512040262295 = "Resources";

// id: "10697249-e96e-4602-b584-eb07a0ed58c4"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "b1468b7f-33b0-40cc-b623-46b3a0a0ae03"
export const PostSlug10697249E96e4602B584Eb07a0ed58c4 = "polytopia-2024";

// id: "c847a337-cc12-4891-81ef-b39eed04dbeb"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "92500507-4e60-4a1f-a91c-f77b1faaca57"
export const ContentSlugC847a337Cc12489181efB39eed04dbeb = "polytopia-2026-handouts-header-with-hero";

// id: "fd5ce675-7b30-4b31-893c-efdda5be33c3"
// title: ""
// type: :text
// key: "className"
// parent_id: "e673878b-6a82-4da4-9fc3-02b393bb9158"
export const ClassNameFd5ce6757b304b31893cEfdda5be33c3 = "public-header-with-hero secondary-page";

// id: "904a1e2b-c08c-4364-b177-914aba47206d"
// title: "Default Header Reference"
// type: :reference
// key: "default-header"
// parent_id: nil
export function DefaultHeader904a1e2bC08c4364B177914aba47206d(props: any) {
  return (
    <ShortHeader98ce7e4a8f244b3691da2cf0511fd380 parentTag="DefaultHeader904a1e2bC08c4364B177914aba47206d" title navMenuSlug="marketing-primary-nav" {...props} />
  );
}

// id: "9145ee07-08c5-4380-adb3-483f1a835655"
// title: "Public Events Page"
// type: :html
// key: "public-events-page"
// parent_id: nil
export function PublicEventsPage9145ee0708c54380Adb3483f1a835655(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicEventsPage9145ee0708c54380Adb3483f1a835655 gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeaderD322727b39004ea6956f5716c320962c parentTag="Header76245fd58d1746feBea752add2f81116" title="Public Events" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="Footer95222eadA93a4b2c863aE810c0213235" {...props} />}
    </div>
  );
}

// id: "4a4fc60b-b4a3-4a0d-b72a-6f0ebf6adeb8"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "cc27fbec-3950-4476-9c33-61b66b58ff7b"
export function Header4a4fc60bB4a34a0dB72a6f0ebf6adeb8(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header4a4fc60bB4a34a0dB72a6f0ebf6adeb8" parentTag={buildClassName("Header4a4fc60bB4a34a0dB72a6f0ebf6adeb8", parentTag)} as="header" contentSlug="polytopia-2026-workshops-header-with-hero" className="public-header-with-hero secondary-page" subType="header_with_hero" {...props} />
  );
}

// id: "9679a72e-6974-4fd0-816a-5a192e535f09"
// title: ""
// type: :gf_preset
// key: "hero"
// parent_id: "c0ec48a7-2bbf-4996-b185-b0e8f64f97cb"
export function Hero9679a72e69744fd0816a5a192e535f09(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Hero className="Hero9679a72e69744fd0816a5a192e535f09" parentTag={buildClassName("Hero9679a72e69744fd0816a5a192e535f09", parentTag)} postSlug="home-hero" {...props} />
  );
}

// id: "8e9f19ec-717f-4ee4-9a04-4ea8e75bf78e"
// title: ""
// type: :gf_preset
// key: "body"
// parent_id: "4b506997-61a3-412d-bcf7-5309887e3743"
export function Body8e9f19ec717f4ee49a044ea8e75bf78e(props: any) {
  const PageContent = AppStore.presets["PageContent"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageContent className="Body8e9f19ec717f4ee49a044ea8e75bf78e" parentTag={buildClassName("Body8e9f19ec717f4ee49a044ea8e75bf78e", parentTag)} {...props} />
  );
}

// id: "51c25f57-a580-4388-ab19-8ddf316b636e"
// title: ""
// type: :gf_preset
// key: "cards"
// parent_id: "3908d6b2-1d25-46f6-a831-1708917b7a92"
export function Cards51c25f57A5804388Ab198ddf316b636e(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="Cards51c25f57A5804388Ab198ddf316b636e" parentTag={buildClassName("Cards51c25f57A5804388Ab198ddf316b636e", parentTag)} postSlug="polytopia-2025" {...props} />
  );
}

// id: "7ffb809a-7101-464c-824a-154022dddf77"
// title: "Footer"
// type: :reference
// key: "footer"
// parent_id: "c9e3ffb4-4ecf-4540-a2cb-858ba2782ba4"
export function Footer7ffb809a7101464c824a154022dddf77(props: any) {
  return (
    <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="Footer7ffb809a7101464c824a154022dddf77" {...props} />
  );
}

// id: "e8860531-bb88-4c11-a491-7dd232f7a31d"
// title: ""
// type: :gf_preset
// key: "cards"
// parent_id: "4072249e-bada-40ff-ba9e-64dab281acbc"
export function CardsE8860531Bb884c11A4917dd232f7a31d(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="CardsE8860531Bb884c11A4917dd232f7a31d" parentTag={buildClassName("CardsE8860531Bb884c11A4917dd232f7a31d", parentTag)} postSlug="polytopia-2025-presenters-cards" {...props} />
  );
}

// id: "026261d5-f117-4c58-b004-045578077b95"
// title: ""
// type: :text
// key: "as"
// parent_id: "83c68578-7525-4f90-b6c8-b16b2b98cae5"
export const As026261d5F1174c58B004045578077b95 = "header";

// id: "a843ac81-bd9b-4816-8046-007b2623c8bb"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "4a4fc60b-b4a3-4a0d-b72a-6f0ebf6adeb8"
export const ContentSlugA843ac81Bd9b48168046007b2623c8bb = "polytopia-2026-workshops-header-with-hero";

// id: "d275c68b-d3bf-43da-b0e7-3231c3d7196c"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "6730e02c-a933-471c-ada3-37da8e10554c"
export const ContentSlugD275c68bD3bf43daB0e73231c3d7196c = "polytopia-2025-header-with-hero";

// id: "f127a780-916b-4e01-8a5c-17959a326bb7"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "5fb41566-cf34-457e-93cf-5bf05232c71d"
export const ContentSlugF127a780916b4e018a5c17959a326bb7 = "polytopia-2026-sponsors";

// id: "05855138-d00f-4b40-b059-2f559d8d9e99"
// title: ""
// type: :text
// key: "className"
// parent_id: "92500507-4e60-4a1f-a91c-f77b1faaca57"
export const ClassName05855138D00f4b40B0592f559d8d9e99 = "public-header-with-hero secondary-page";

// id: "ec2efbf9-428e-4f18-8793-c61ac4b78538"
// title: "Marketing Cards"
// type: :gf_preset
// key: "marketing-cards"
// parent_id: nil
export function MarketingCardsEc2efbf9428e4f188793C61ac4b78538(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="MarketingCardsEc2efbf9428e4f188793C61ac4b78538" parentTag={buildClassName("MarketingCardsEc2efbf9428e4f188793C61ac4b78538", parentTag)} postSlug="home-page-posts2" buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" {...props} />
  );
}

// id: "df950adf-456f-4805-97ba-0f1198c81e87"
// title: "Polytopia 2026 Handouts"
// type: :html
// key: "polytopia-2026-handouts"
// parent_id: nil
export function Polytopia2026HandoutsDf950adf456f480597ba0f1198c81e87(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia2026HandoutsDf950adf456f480597ba0f1198c81e87 page gf-page-layout page gf-page-layout`}>
      {props["header"] || <ContentItem className="Header925005074e604a1fA91cF77b1faaca57" parentTag={buildClassName("Header925005074e604a1fA91cF77b1faaca57", parentTag)} subType="header_with_hero" contentSlug="polytopia-2026-handouts-header-with-hero" className="public-header-with-hero secondary-page" as="header" {...props} />}
      <main>
        {props["main-content"] || <PageContentSimplified className="MainContent4b8343b6B2734bd1B9169407681e74bb" parentTag={buildClassName("MainContent4b8343b6B2734bd1B9169407681e74bb", parentTag)} contentSlug="polytopia-2026-handouts-main" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="FooterD3d5470662204367A24275c2d034aa53" {...props} />}
    </div>
  );
}

// id: "db3480c8-2b18-4a72-a971-53bc1e0e6dbc"
// title: "Header Clone SiJc8owDIOQgqYh Clone F82SSDIS4SM8PPXZH Clone FAQQBXNH68T50FSXS"
// type: :gf_preset
// key: "header"
// parent_id: "4072249e-bada-40ff-ba9e-64dab281acbc"
export function HeaderDb3480c82b184a72A97153bc1e0e6dbc(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="HeaderDb3480c82b184a72A97153bc1e0e6dbc" parentTag={buildClassName("HeaderDb3480c82b184a72A97153bc1e0e6dbc", parentTag)} contentSlug="polytopia-2025-presenters-header-with-hero" subType="header_with_hero" as="header" className="public-header-with-hero secondary-page" {...props} />
  );
}

// id: "76245fd5-8d17-46fe-bea7-52add2f81116"
// title: ""
// type: :reference
// key: "header"
// parent_id: "9145ee07-08c5-4380-adb3-483f1a835655"
export function Header76245fd58d1746feBea752add2f81116(props: any) {
  return (
    <SecondaryMarketingHeaderD322727b39004ea6956f5716c320962c parentTag="Header76245fd58d1746feBea752add2f81116" title="Public Events" {...props} />
  );
}

// id: "65e9ab41-9133-447e-900d-5d9741d3e7cb"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "4b506997-61a3-412d-bcf7-5309887e3743"
export function Footer65e9ab419133447e900d5d9741d3e7cb(props: any) {
  return (
    <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="Footer65e9ab419133447e900d5d9741d3e7cb" {...props} />
  );
}

// id: "25314445-a50b-4b9d-bf98-eeeba79428ab"
// title: ""
// type: :reference
// key: "header"
// parent_id: "7baaf22f-8a94-416f-957e-d14924005b83"
export function Header25314445A50b4b9dBf98Eeeba79428ab(props: any) {
  return (
    <SecondaryMarketingHeaderD322727b39004ea6956f5716c320962c parentTag="Header25314445A50b4b9dBf98Eeeba79428ab" title="Resources" {...props} />
  );
}

// id: "76cf718a-ec42-4c61-97bd-8f531c0c1998"
// title: ""
// type: :reference
// key: "header"
// parent_id: "63e50fdb-1935-4ee0-ad40-b4d6b3bd4311"
export function Header76cf718aEc424c6197bd8f531c0c1998(props: any) {
  return (
    <SecondaryMarketingHeaderD322727b39004ea6956f5716c320962c parentTag="Header76cf718aEc424c6197bd8f531c0c1998" title="About Us" {...props} />
  );
}

// id: "bf7d402a-2ed3-47cd-bbf9-51304df26899"
// title: "Footer Clone xRXtkVcbB7vf9dR Clone I9XQT7FHAZPJGAC15"
// type: :reference
// key: "footer"
// parent_id: "8c3a11ae-70fb-4398-8569-42bcd6be18d1"
export function FooterBf7d402a2ed347cdBbf951304df26899(props: any) {
  return (
    <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="FooterBf7d402a2ed347cdBbf951304df26899" {...props} />
  );
}

// id: "42214633-fbd9-45da-bf72-c8b0a7f568d9"
// title: ""
// type: :text
// key: "className"
// parent_id: "6730e02c-a933-471c-ada3-37da8e10554c"
export const ClassName42214633Fbd945daBf72C8b0a7f568d9 = "public-header-with-hero secondary-page";

// id: "695f806c-bd2e-45f1-921c-d515bf905488"
// title: ""
// type: :text
// key: "className"
// parent_id: "fba5956a-be28-463d-b0b2-9af03b3977c3"
export const ClassName695f806cBd2e45f1921cD515bf905488 = "public-header-with-hero secondary-page";

// id: "22b616a2-7857-4aa5-8c45-f16be7f9ae91"
// title: "Logo"
// type: :html
// key: "default-logo"
// parent_id: nil
export function DefaultLogo22b616a278574aa58c45F16be7f9ae91(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <img src="https://mp1md-pub.s3.us-west-2.amazonaws.com/spp-logo.svg" className={`${parentTag || ""} DefaultLogo22b616a278574aa58c45F16be7f9ae91 logo`} alt="logo" />
  );
}

// id: "aba48207-a5c3-4fdc-96e4-3317026c1125"
// title: "Secondary Page"
// type: :html
// key: "secondary-page"
// parent_id: nil
export function SecondaryPageAba48207A5c34fdc96e43317026c1125(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryPageAba48207A5c34fdc96e43317026c1125 gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeaderD322727b39004ea6956f5716c320962c parentTag="Header7129478860db4acf8ce15d1c09e88ad8" title="Secondary Page" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="FooterDc18476cE9164ba198663b407d07fa0f" {...props} />}
    </div>
  );
}

// id: "a40ccb8f-1e17-48fa-bfa5-7fef9a770c87"
// title: ""
// type: :gf_preset
// key: "cards"
// parent_id: "8c3a11ae-70fb-4398-8569-42bcd6be18d1"
export function CardsA40ccb8f1e1748faBfa57fef9a770c87(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="CardsA40ccb8f1e1748faBfa57fef9a770c87" parentTag={buildClassName("CardsA40ccb8f1e1748faBfa57fef9a770c87", parentTag)} postSlug="polytopia-2025-sponsors" {...props} />
  );
}

// id: "465a3355-f948-47c4-8642-cc65fe8ce945"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "431498e3-a11c-4d75-9a7b-b4c9f9cf7c75"
export function Links465a3355F94847c48642Cc65fe8ce945(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="Links465a3355F94847c48642Cc65fe8ce945" parentTag={buildClassName("Links465a3355F94847c48642Cc65fe8ce945", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "fd1f85b6-eb5f-4f9a-a5f6-b50feee66ee1"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "897ce2cb-acaf-4349-b146-3421534478b4"
export function HeaderTopFd1f85b6Eb5f4f9aA5f6B50feee66ee1(props: any) {
  return (
    <DefaultHeaderTopB5b2de7c36d94c739f44306fa937c712 parentTag="HeaderTopFd1f85b6Eb5f4f9aA5f6B50feee66ee1" navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "8e896507-806f-48ac-82b4-910bba017cdb"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "301b0b82-8030-4324-a772-e738b349e1b2"
export function Footer8e896507806f48ac82b4910bba017cdb(props: any) {
  return (
    <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="Footer8e896507806f48ac82b4910bba017cdb" {...props} />
  );
}

// id: "5f229a49-b41f-4fdf-ae94-9a465af09b6b"
// title: ""
// type: :text
// key: "title"
// parent_id: "904a1e2b-c08c-4364-b177-914aba47206d"
export const Title5f229a49B41f4fdfAe949a465af09b6b = null;

// id: "ff3b1a5e-a98c-4b45-a811-6c996f32446e"
// title: ""
// type: :text
// key: "title"
// parent_id: "2a580a58-ae5b-4c08-a86e-aa6b1313a1ff"
export const TitleFf3b1a5eA98c4b45A8116c996f32446e = "Default Title";

// id: "b0f3a0c2-c2cf-4a9f-b597-930f1299c07e"
// title: ""
// type: :text
// key: "title"
// parent_id: "6c19d680-0f0b-4753-b047-b5e66481f1a5"
export const TitleB0f3a0c2C2cf4a9fB597930f1299c07e = "Polytopia 2024";

// id: "88e2d98d-12e1-418f-8417-da0459390cf7"
// title: ""
// type: :text
// key: "className"
// parent_id: "7a7f29c6-eef7-4734-add6-bf3f38e05bb4"
export const ClassName88e2d98d12e1418f8417Da0459390cf7 = "intro-text";

// id: "2995b81f-04e6-472a-bd58-f5a209ab232e"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "422edffb-989f-4c33-82c7-f6696a97485e"
export const PostSlug2995b81f04e6472aBd58F5a209ab232e = "home-page-posts2";

// id: "7b49573f-79cd-4433-b848-7b287f68b17f"
// title: ""
// type: :text
// key: "as"
// parent_id: "db3480c8-2b18-4a72-a971-53bc1e0e6dbc"
export const As7b49573f79cd4433B8487b287f68b17f = "header";

// id: "57443230-4986-4090-b800-f0eb1f22d2ea"
// title: ""
// type: :text
// key: "as"
// parent_id: "fba5956a-be28-463d-b0b2-9af03b3977c3"
export const As5744323049864090B800F0eb1f22d2ea = "header";

// id: "7085f7cc-b277-4271-9297-c9aae5c94dc1"
// title: "Common Footer"
// type: :reference
// key: "footer"
// parent_id: nil
export function Footer7085f7ccB27742719297C9aae5c94dc1(props: any) {
  return (
    <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="Footer7085f7ccB27742719297C9aae5c94dc1" {...props} />
  );
}

// id: "301b0b82-8030-4324-a772-e738b349e1b2"
// title: "Member Pages"
// type: :html
// key: "member-pages"
// parent_id: nil
export function MemberPages301b0b8280304324A772E738b349e1b2(props: any) {
  const SecondaryNavigation = AppStore.presets["SecondaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MemberPages301b0b8280304324A772E738b349e1b2 gf-page-layout`}>
      {props["header"] || <MembersAreaHeader897ce2cbAcaf4349B1463421534478b4 parentTag="Header1535227388af40c0B1846eff6debaf9b" {...props} />}
      {props["secondary-nav"] || <SecondaryNavigation className="SecondaryNav8825200368a94a94Bfa2Fe799adbf5f7" parentTag={buildClassName("SecondaryNav8825200368a94a94Bfa2Fe799adbf5f7", parentTag)} {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="Footer8e896507806f48ac82b4910bba017cdb" {...props} />}
    </div>
  );
}

// id: "1e37ae2b-d76c-4a3a-920f-b9cfa84249bc"
// title: "Footer Clone xRXtkVcbB7vf9dR"
// type: :reference
// key: "footer"
// parent_id: "3908d6b2-1d25-46f6-a831-1708917b7a92"
export function Footer1e37ae2bD76c4a3a920fB9cfa84249bc(props: any) {
  return (
    <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="Footer1e37ae2bD76c4a3a920fB9cfa84249bc" {...props} />
  );
}

// id: "5e9c485d-1d3f-4df6-810c-2ac6e28b9128"
// title: ""
// type: :reference
// key: "body"
// parent_id: "01b053d6-cc6b-4446-a8d6-5d66d79a4726"
export function Body5e9c485d1d3f4df6810c2ac6e28b9128(props: any) {
  return (
    <MarketingBody3e8d1d1aCf554de8979d33d4b536ae88 parentTag="Body5e9c485d1d3f4df6810c2ac6e28b9128" {...props} />
  );
}

// id: "e5ec72f3-9a1e-40e2-91bb-a7e769639fb1"
// title: ""
// type: :reference
// key: "header"
// parent_id: "01b053d6-cc6b-4446-a8d6-5d66d79a4726"
export function HeaderE5ec72f39a1e40e291bbA7e769639fb1(props: any) {
  return (
    <HomeHeaderC0ec48a72bbf4996B185B0e8f64f97cb parentTag="HeaderE5ec72f39a1e40e291bbA7e769639fb1" {...props} />
  );
}

// id: "082a3554-b4d7-4a31-b87a-af8490a5ae71"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "431498e3-a11c-4d75-9a7b-b4c9f9cf7c75"
export function Groupflow082a3554B4d74a31B87aAf8490a5ae71(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow082a3554B4d74a31B87aAf8490a5ae71" parentTag={buildClassName("Groupflow082a3554B4d74a31B87aAf8490a5ae71", parentTag)} {...props} />
  );
}

// id: "467cf535-59df-4392-ad77-6c9b62c77c9e"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "53d2139f-7035-49b7-9a7c-39e0e90bc458"
export function Footer467cf53559df4392Ad776c9b62c77c9e(props: any) {
  return (
    <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="Footer467cf53559df4392Ad776c9b62c77c9e" {...props} />
  );
}

// id: "5c039683-ceb3-423e-b671-a4f6e2bce508"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "01b053d6-cc6b-4446-a8d6-5d66d79a4726"
export function Footer5c039683Ceb3423eB671A4f6e2bce508(props: any) {
  return (
    <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="Footer5c039683Ceb3423eB671A4f6e2bce508" {...props} />
  );
}

// id: "0a358c62-c185-4d88-986e-1d4122157f91"
// title: ""
// type: :text
// key: "url"
// parent_id: "4f34f9d5-d9e0-4c75-9677-ec0acd91bf48"
export const Url0a358c62C1854d88986e1d4122157f91 = "/";

// id: "102f6f8d-5344-4209-a556-ea69ef1bb107"
// title: ""
// type: :text
// key: "className"
// parent_id: "75aa199d-900b-4636-941d-3703ca282a4e"
export const ClassName102f6f8d53444209A556Ea69ef1bb107 = "public-header-with-hero secondary-page";

// id: "6dbd78f2-53a6-475b-8063-66299a178059"
// title: ""
// type: :text
// key: "title"
// parent_id: "78400dd8-8d28-4c6b-b15c-32fb36211fa1"
export const Title6dbd78f253a6475b806366299a178059 = "Leveling";

// id: "6f437bde-1dc7-4529-aaf9-362381893b70"
// title: ""
// type: :text
// key: "subType"
// parent_id: "75aa199d-900b-4636-941d-3703ca282a4e"
export const SubType6f437bde1dc74529Aaf9362381893b70 = "header_with_hero";

// id: "911b562e-4f41-439f-ad52-6089b7535d8e"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "7a7f29c6-eef7-4734-add6-bf3f38e05bb4"
export const ContentSlug911b562e4f41439fAd526089b7535d8e = "polytopia-2025-presenters-intro-text";

// id: "a370469a-f19c-4ff2-b7cc-592b39e67e7a"
// title: "HREF"
// type: :text
// key: "href"
// parent_id: nil
export const HrefA370469aF19c4ff2B7cc592b39e67e7a = "/";

// id: "2a580a58-ae5b-4c08-a86e-aa6b1313a1ff"
// title: "Secondary Marketing Hero"
// type: :html
// key: "secondary-marketing-hero"
// parent_id: nil
export function SecondaryMarketingHero2a580a58Ae5b4c08A86eAa6b1313a1ff(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHero2a580a58Ae5b4c08A86eAa6b1313a1ff hero`}>
      <div className="title">
        {props["title"] || TitleFf3b1a5eA98c4b45A8116c996f32446e}
      </div>
    </div>
  );
}

// id: "5e5f23fd-e569-4f24-b094-297999e634fe"
// title: "Footer Clone xRXtkVcbB7vf9dR Clone PDYMUIYORNVKPIXNX"
// type: :reference
// key: "footer"
// parent_id: "2394baa1-cb1e-48d3-ab02-c8c97332f98c"
export function Footer5e5f23fdE5694f24B094297999e634fe(props: any) {
  return (
    <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="Footer5e5f23fdE5694f24B094297999e634fe" {...props} />
  );
}

// id: "2b394248-560f-4ba6-864c-de16b2fb7504"
// title: ""
// type: :text
// key: "title"
// parent_id: "d322727b-3900-4ea6-956f-5716c320962c"
export const Title2b394248560f4ba6864cDe16b2fb7504 = "Secondary Marketing Title 1";

// id: "c8366c9c-32d2-4d11-846a-0a250865c871"
// title: ""
// type: :gf_preset
// key: "quote"
// parent_id: "01b053d6-cc6b-4446-a8d6-5d66d79a4726"
export function QuoteC8366c9c32d24d11846a0a250865c871(props: any) {
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageQuote className="QuoteC8366c9c32d24d11846a0a250865c871" parentTag={buildClassName("QuoteC8366c9c32d24d11846a0a250865c871", parentTag)} contentSlug="home-page-quote" {...props} />
  );
}

// id: "6926554b-ff71-4fa7-a400-0e350f433c1b"
// title: "Footer Clone xRXtkVcbB7vf9dR Clone I9XQT7FHAZPJGAC15 Clone YBYEQWBTJ7M1RURES Clone IP70JVLKGR2BY5BJB"
// type: :reference
// key: "footer"
// parent_id: "a1c5efd5-78e1-4cbb-9a6c-abc7c6676c62"
export function Footer6926554bFf714fa7A4000e350f433c1b(props: any) {
  return (
    <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="Footer6926554bFf714fa7A4000e350f433c1b" {...props} />
  );
}

// id: "34d95305-57bf-4775-a8f2-3a3789f0732a"
// title: ""
// type: :reference
// key: "header"
// parent_id: "66b3d74d-5000-4992-87bf-050a85ad6cca"
export function Header34d9530557bf4775A8f23a3789f0732a(props: any) {
  return (
    <SecondaryMarketingHeaderD322727b39004ea6956f5716c320962c parentTag="Header34d9530557bf4775A8f23a3789f0732a" title="Join Us" {...props} />
  );
}

// id: "34f631c1-cd42-400d-b02e-98789a562436"
// title: ""
// type: :html
// key: "logo"
// parent_id: "431498e3-a11c-4d75-9a7b-b4c9f9cf7c75"
export function Logo34f631c1Cd42400dB02e98789a562436(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <img src="https://mp1md-pub.s3.amazonaws.com/spp/images/spp-logo-white.svg" alt="SPP logo" className={`${parentTag || ""} Logo34f631c1Cd42400dB02e98789a562436 logo`} />
  );
}

// id: "c9977de5-faa3-4895-b9f9-829989726b38"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "9cefac05-fa82-4f9c-81e7-f6da92cd8b7d"
export const NavMenuSlugC9977de5Faa34895B9f9829989726b38 = "members-primary-nav";

// id: "dc9df452-650b-46f3-b77e-5c5cceca3b03"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "9aafe6f7-00df-4917-bba6-93421ba69b4f"
export const ContentSlugDc9df452650b46f3B77e5c5cceca3b03 = "polytopia-2025-schedule-header-with-hero";

// id: "3387b5e1-185b-4c06-bdc5-d931d226971b"
// title: ""
// type: :reference
// key: "label"
// parent_id: "edf6a11b-848c-4669-ae8a-52ba221e8196"
export function Label3387b5e1185b4c06Bdc5D931d226971b(props: any) {
  return (
    <DefaultLogo22b616a278574aa58c45F16be7f9ae91 parentTag="Label3387b5e1185b4c06Bdc5D931d226971b" {...props} />
  );
}

// id: "68e4bfc4-b853-4f75-8748-dbb742846763"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "26466f02-bb7c-4e46-ae35-f29a63c66657"
export const ContentSlug68e4bfc4B8534f758748Dbb742846763 = "polytopia-2025-sponsors-intro";

// id: "42764855-cade-4ae0-9ee1-aba3301a6d6d"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "75aa199d-900b-4636-941d-3703ca282a4e"
export const ContentSlug42764855Cade4ae09ee1Aba3301a6d6d = "polytopia-2025-sponsors-header-with-hero";

// id: "4ad1675c-4e1d-49c1-a127-a385f60f9c53"
// title: "Home Page Hero"
// type: :html
// key: "home-page-hero"
// parent_id: nil
export function HomePageHero4ad1675c4e1d49c1A127A385f60f9c53(props: any) {
  const Button = AppStore.presets["Button"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePageHero4ad1675c4e1d49c1A127A385f60f9c53 hero`}>
      <div className="title">
        Our mission is to change the world by promoting healthy sexuality through community and education.
      </div>
      <div className="button">
        {props["button"] || <Button className="Button5984183c2321474d8ca2Bee03d8971b2" parentTag={buildClassName("Button5984183c2321474d8ca2Bee03d8971b2", parentTag)} href="/join" label="Join Us" {...props} />}
      </div>
    </div>
  );
}

// id: "01b053d6-cc6b-4446-a8d6-5d66d79a4726"
// title: "Home Page"
// type: :html
// key: "home-page"
// parent_id: nil
export function HomePage01b053d6Cc6b4446A8d65d66d79a4726(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePage01b053d6Cc6b4446A8d65d66d79a4726 page gf-page-layout page gf-page-layout`}>
      {props["header"] || <HomeHeaderC0ec48a72bbf4996B185B0e8f64f97cb parentTag="HeaderE5ec72f39a1e40e291bbA7e769639fb1" {...props} />}
      {props["welcome-back"] || <WelcomeBackPopUp className="WelcomeBack7107d24bA8484ed388bbD41f9e5e49e8" parentTag={buildClassName("WelcomeBack7107d24bA8484ed388bbD41f9e5e49e8", parentTag)} {...props} />}
      {props["body"] || <MarketingBody3e8d1d1aCf554de8979d33d4b536ae88 parentTag="Body5e9c485d1d3f4df6810c2ac6e28b9128" {...props} />}
      {props["quote"] || <PageQuote className="QuoteC8366c9c32d24d11846a0a250865c871" parentTag={buildClassName("QuoteC8366c9c32d24d11846a0a250865c871", parentTag)} contentSlug="home-page-quote" {...props} />}
      {props["footer"] || <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="Footer5c039683Ceb3423eB671A4f6e2bce508" {...props} />}
    </div>
  );
}

// id: "92500507-4e60-4a1f-a91c-f77b1faaca57"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "df950adf-456f-4805-97ba-0f1198c81e87"
export function Header925005074e604a1fA91cF77b1faaca57(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header925005074e604a1fA91cF77b1faaca57" parentTag={buildClassName("Header925005074e604a1fA91cF77b1faaca57", parentTag)} subType="header_with_hero" contentSlug="polytopia-2026-handouts-header-with-hero" className="public-header-with-hero secondary-page" as="header" {...props} />
  );
}

// id: "88252003-68a9-4a94-bfa2-fe799adbf5f7"
// title: ""
// type: :gf_preset
// key: "secondary-nav"
// parent_id: "301b0b82-8030-4324-a772-e738b349e1b2"
export function SecondaryNav8825200368a94a94Bfa2Fe799adbf5f7(props: any) {
  const SecondaryNavigation = AppStore.presets["SecondaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <SecondaryNavigation className="SecondaryNav8825200368a94a94Bfa2Fe799adbf5f7" parentTag={buildClassName("SecondaryNav8825200368a94a94Bfa2Fe799adbf5f7", parentTag)} {...props} />
  );
}

// id: "de7e30e6-26d6-45d9-ad10-d66fcdeadb79"
// title: "Header"
// type: :gf_preset
// key: "header"
// parent_id: "2394baa1-cb1e-48d3-ab02-c8c97332f98c"
export function HeaderDe7e30e626d645d9Ad10D66fcdeadb79(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="HeaderDe7e30e626d645d9Ad10D66fcdeadb79" parentTag={buildClassName("HeaderDe7e30e626d645d9Ad10D66fcdeadb79", parentTag)} as="header" contentSlug="polytopia-2026-header-with-hero" subType="header_with_hero" className="public-header-with-hero secondary-page" {...props} />
  );
}

// id: "4f87b07d-15f5-443c-88f9-ca828939ffbd"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "08dd2a7c-03af-4d94-b901-fbe2d2af471a"
export function Header4f87b07d15f5443c88f9Ca828939ffbd(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header4f87b07d15f5443c88f9Ca828939ffbd" parentTag={buildClassName("Header4f87b07d15f5443c88f9Ca828939ffbd", parentTag)} as="header" contentSlug="polytopia-2026-sponsors-header-with-hero" subType="header_with_hero" className="public-header-with-hero secondary-page" {...props} />
  );
}

// id: "810aebb7-d028-4348-93bf-aebf4f399b2b"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "98ce7e4a-8f24-4b36-91da-2cf0511fd380"
export function Navigation810aebb7D028434893bfAebf4f399b2b(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="Navigation810aebb7D028434893bfAebf4f399b2b" parentTag={buildClassName("Navigation810aebb7D028434893bfAebf4f399b2b", parentTag)} navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "39ef6466-a05a-4757-9d9e-d4ae7d92e7ab"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "b7f57dea-85d9-4fcb-a380-8e0616076d1a"
export function Footer39ef6466A05a47579d9eD4ae7d92e7ab(props: any) {
  return (
    <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="Footer39ef6466A05a47579d9eD4ae7d92e7ab" {...props} />
  );
}

// id: "e2459b1b-ec77-4e7a-aae4-9d8639cd248a"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "60351a5d-8a40-48e4-993f-1c30e4e7cdc8"
export const ContentSlugE2459b1bEc774e7aAae49d8639cd248a = "polytopia-2025-handouts-main";

// id: "2b37737a-d25a-4d5b-a0c5-288d6abb6a5c"
// title: ""
// type: :text
// key: "title"
// parent_id: "76245fd5-8d17-46fe-bea7-52add2f81116"
export const Title2b37737aD25a4d5bA0c5288d6abb6a5c = "Public Events";

// id: "279fce13-ecc7-45de-a54b-ac8f530ac03a"
// title: ""
// type: :text
// key: "as"
// parent_id: "6730e02c-a933-471c-ada3-37da8e10554c"
export const As279fce13Ecc745deA54bAc8f530ac03a = "header";

// id: "c6a2d947-d701-4ab9-aab4-91e2f2cea07a"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "326b96d8-b838-4e9e-9300-f8e5f7e44234"
export const NavMenuSlugC6a2d947D7014ab9Aab491e2f2cea07a = "marketing-primary-nav";

// id: "b5b2de7c-36d9-4c73-9f44-306fa937c712"
// title: "Header Area Top"
// type: :html
// key: "default-header-top"
// parent_id: nil
export function DefaultHeaderTopB5b2de7c36d94c739f44306fa937c712(props: any) {
  const Link = AppStore.presets["Link"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} DefaultHeaderTopB5b2de7c36d94c739f44306fa937c712 header-top`}>
      {props["linked-logo"] || <Link className="LinkedLogo4f34f9d5D9e04c759677Ec0acd91bf48" parentTag={buildClassName("LinkedLogo4f34f9d5D9e04c759677Ec0acd91bf48", parentTag)} className="linked-logo" url="/" label={<DefaultLogo22b616a278574aa58c45F16be7f9ae91 parentTag="LabelBb7b9fa9340345f6A5d6F603976fd0b1" alt="logo" />} {...props} />}
      {props["navigation"] || <PrimaryNavigation className="Navigation326b96d8B8384e9e9300F8e5f7e44234" parentTag={buildClassName("Navigation326b96d8B8384e9e9300F8e5f7e44234", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />}
    </div>
  );
}

// id: "08dd2a7c-03af-4d94-b901-fbe2d2af471a"
// title: "Polytopia 2026 Schedule"
// type: :html
// key: "polytopia-2026-schedule"
// parent_id: nil
export function Polytopia2026Schedule08dd2a7c03af4d94B901Fbe2d2af471a(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia2026Schedule08dd2a7c03af4d94B901Fbe2d2af471a page gf-page-layout page gf-page-layout`}>
      {props["header"] || <ContentItem className="Header4f87b07d15f5443c88f9Ca828939ffbd" parentTag={buildClassName("Header4f87b07d15f5443c88f9Ca828939ffbd", parentTag)} as="header" contentSlug="polytopia-2026-sponsors-header-with-hero" subType="header_with_hero" className="public-header-with-hero secondary-page" {...props} />}
      <main>
        {props["main-content"] || <PageContentSimplified className="MainContentE17cdbc665c4441284adEc551ebb4118" parentTag={buildClassName("MainContentE17cdbc665c4441284adEc551ebb4118", parentTag)} contentSlug="polytopia-2026-schedule-main" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="FooterFd7c4072D8dd4f3bA0cc3c69d210a332" {...props} />}
    </div>
  );
}

// id: "6fd55348-00ee-4813-ab7c-c1822e21bb36"
// title: ""
// type: :gf_preset
// key: "sponsors"
// parent_id: "7ee34b54-5872-4ca7-9dba-3aecfdd5e711"
export function Sponsors6fd5534800ee4813Ab7cC1822e21bb36(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="Sponsors6fd5534800ee4813Ab7cC1822e21bb36" parentTag={buildClassName("Sponsors6fd5534800ee4813Ab7cC1822e21bb36", parentTag)} {...props} />
  );
}

// id: "9cefac05-fa82-4f9c-81e7-f6da92cd8b7d"
// title: ""
// type: :reference
// key: "header"
// parent_id: "53d2139f-7035-49b7-9a7c-39e0e90bc458"
export function Header9cefac05Fa824f9c81e7F6da92cd8b7d(props: any) {
  return (
    <MembersAreaHeader897ce2cbAcaf4349B1463421534478b4 parentTag="Header9cefac05Fa824f9c81e7F6da92cd8b7d" navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "ea72806d-9249-4261-8817-e93c705387a2"
// title: ""
// type: :gf_preset
// key: "sponsors"
// parent_id: "08dd2a7c-03af-4d94-b901-fbe2d2af471a"
export function SponsorsEa72806d924942618817E93c705387a2(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="SponsorsEa72806d924942618817E93c705387a2" parentTag={buildClassName("SponsorsEa72806d924942618817E93c705387a2", parentTag)} {...props} />
  );
}

// id: "ac342f72-8ff7-4f6a-b99a-8e91c952cd4c"
// title: ""
// type: :gf_preset
// key: "intro"
// parent_id: "7ee34b54-5872-4ca7-9dba-3aecfdd5e711"
export function IntroAc342f728ff74f6aB99a8e91c952cd4c(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="IntroAc342f728ff74f6aB99a8e91c952cd4c" parentTag={buildClassName("IntroAc342f728ff74f6aB99a8e91c952cd4c", parentTag)} contentSlug="polytopia-2026-sponsors-intro" {...props} />
  );
}

// id: "a862405c-0e0f-4bea-954d-e61702a95d3d"
// title: "Footer Clone xRXtkVcbB7vf9dR Clone I9XQT7FHAZPJGAC15 Clone YBYEQWBTJ7M1RURES Clone 9QERD06Z1IRV6P2WO Clone RA2IOSI5WU9MZT94L Clone X60TRD0XRW2DZ77ZB"
// type: :reference
// key: "footer"
// parent_id: "1ac7c8ab-0c03-4635-ae90-9d9ceefc0042"
export function FooterA862405c0e0f4bea954dE61702a95d3d(props: any) {
  return (
    <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="FooterA862405c0e0f4bea954dE61702a95d3d" {...props} />
  );
}

// id: "8c9903d2-97f3-43a5-a727-b422ac9ffcae"
// title: ""
// type: :reference
// key: "header"
// parent_id: "e9cede63-cd1f-4ab3-88e7-18a811b72970"
export function Header8c9903d297f343a5A727B422ac9ffcae(props: any) {
  return (
    <SecondaryMarketingHeaderD322727b39004ea6956f5716c320962c parentTag="Header8c9903d297f343a5A727B422ac9ffcae" title="Join Us" {...props} />
  );
}

// id: "3df6d107-60af-43a1-89c2-ac719ffe123e"
// title: ""
// type: :text
// key: "className"
// parent_id: "cb7df874-0390-43e8-98bc-667dba362100"
export const ClassName3df6d10760af43a189c2Ac719ffe123e = "intro-text";

// id: "a7fa7e35-0eec-452b-b738-d7e208982f2e"
// title: ""
// type: :text
// key: "href"
// parent_id: "5984183c-2321-474d-8ca2-bee03d8971b2"
export const HrefA7fa7e350eec452bB738D7e208982f2e = "/join";

// id: "3b1f6f07-2323-4bde-8556-9e807afdd832"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "fd1f85b6-eb5f-4f9a-a5f6-b50feee66ee1"
export const NavMenuSlug3b1f6f0723234bde85569e807afdd832 = "members-primary-nav";

// id: "51385c48-7598-490f-9f5d-36aaf268dda1"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "465a3355-f948-47c4-8642-cc65fe8ce945"
export const NavMenuSlug51385c487598490f9f5d36aaf268dda1 = "footer-nav";

// id: "98ce7e4a-8f24-4b36-91da-2cf0511fd380"
// title: "Short Header"
// type: :html
// key: "short-header"
// parent_id: nil
export function ShortHeader98ce7e4a8f244b3691da2cf0511fd380(props: any) {
  const Link = AppStore.presets["Link"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} ShortHeader98ce7e4a8f244b3691da2cf0511fd380 site-header`}>
      <div className="background-image" />
      <div className="header-top">
        {props["linked-logo"] || <Link className="LinkedLogoEdf6a11b848c4669Ae8a52ba221e8196" parentTag={buildClassName("LinkedLogoEdf6a11b848c4669Ae8a52ba221e8196", parentTag)} label={<DefaultLogo22b616a278574aa58c45F16be7f9ae91 parentTag="Label3387b5e1185b4c06Bdc5D931d226971b" alt="logo" />} {...props} />}
        {props["navigation"] || <PrimaryNavigation className="Navigation810aebb7D028434893bfAebf4f399b2b" parentTag={buildClassName("Navigation810aebb7D028434893bfAebf4f399b2b", parentTag)} navMenuSlug="members-primary-nav" {...props} />}
      </div>
    </div>
  );
}

// id: "3e8d1d1a-cf55-4de8-979d-33d4b536ae88"
// title: "Marketing Cards Body"
// type: :html
// key: "marketing-body"
// parent_id: nil
export function MarketingBody3e8d1d1aCf554de8979d33d4b536ae88(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MarketingBody3e8d1d1aCf554de8979d33d4b536ae88 page-body`}>
      {props["marketingCards"] || <MarketingCardsEc2efbf9428e4f188793C61ac4b78538 parentTag="MarketingCards422edffb989f4c3382c7F6696a97485e" postSlug="home-page-posts2" {...props} />}
    </div>
  );
}

// id: "51cf605e-f96b-420b-9616-a59f1ae194b0"
// title: ""
// type: :gf_preset
// key: "sponsors"
// parent_id: "f1695465-f9cb-43fb-bd34-0a8711450b63"
export function Sponsors51cf605eF96b420b9616A59f1ae194b0(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="Sponsors51cf605eF96b420b9616A59f1ae194b0" parentTag={buildClassName("Sponsors51cf605eF96b420b9616A59f1ae194b0", parentTag)} {...props} />
  );
}

// id: "326b96d8-b838-4e9e-9300-f8e5f7e44234"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "b5b2de7c-36d9-4c73-9f44-306fa937c712"
export function Navigation326b96d8B8384e9e9300F8e5f7e44234(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="Navigation326b96d8B8384e9e9300F8e5f7e44234" parentTag={buildClassName("Navigation326b96d8B8384e9e9300F8e5f7e44234", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />
  );
}

// id: "d16ea53d-52d1-46b5-a684-252e41a4cfbc"
// title: ""
// type: :gf_preset
// key: "cards"
// parent_id: "7ee34b54-5872-4ca7-9dba-3aecfdd5e711"
export function CardsD16ea53d52d146b5A684252e41a4cfbc(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="CardsD16ea53d52d146b5A684252e41a4cfbc" parentTag={buildClassName("CardsD16ea53d52d146b5A684252e41a4cfbc", parentTag)} postSlug="polytopia-2026-sponsors-cards" {...props} />
  );
}

// id: "a34c7552-d66b-4944-914d-de47e744e4ec"
// title: "Footer Clone xRXtkVcbB7vf9dR Clone I9XQT7FHAZPJGAC15 Clone YBYEQWBTJ7M1RURES"
// type: :reference
// key: "footer"
// parent_id: "4072249e-bada-40ff-ba9e-64dab281acbc"
export function FooterA34c7552D66b4944914dDe47e744e4ec(props: any) {
  return (
    <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="FooterA34c7552D66b4944914dDe47e744e4ec" {...props} />
  );
}

// id: "04ea1bcf-cc3a-4ffa-8fc0-0ca7f9bc4f27"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "05732d95-2d13-4764-8335-e543c068dc94"
export const PostSlug04ea1bcfCc3a4ffa8fc00ca7f9bc4f27 = "polytopia-2026-cards";

// id: "ab3ea133-f578-4885-9f0a-f62794f3af6a"
// title: ""
// type: :text
// key: "subType"
// parent_id: "4f87b07d-15f5-443c-88f9-ca828939ffbd"
export const SubTypeAb3ea133F57848859f0aF62794f3af6a = "header_with_hero";

// id: "ca723d2e-d1ed-4e2b-8e59-e8ce6b3b5d75"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "231083a5-91cc-4c38-8d31-b416c279df65"
export const ContentSlugCa723d2eD1ed4e2b8e59E8ce6b3b5d75 = "polytopia-2025-workshops-content";

// id: "41b0417b-5aa6-4fa2-80a3-46d35528d9bb"
// title: ""
// type: :text
// key: "subType"
// parent_id: "9aafe6f7-00df-4917-bba6-93421ba69b4f"
export const SubType41b0417b5aa64fa280a346d35528d9bb = "header_with_hero";

// id: "99749698-f12b-404a-a17a-afb48fd2583e"
// title: ""
// type: :text
// key: "as"
// parent_id: "e673878b-6a82-4da4-9fc3-02b393bb9158"
export const As99749698F12b404aA17aAfb48fd2583e = "header";

// id: "1ac7c8ab-0c03-4635-ae90-9d9ceefc0042"
// title: "Polytopia 2025 Handouts"
// type: :html
// key: "polytopia-2025-handouts"
// parent_id: nil
export function Polytopia2025Handouts1ac7c8ab0c034635Ae909d9ceefc0042(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia2025Handouts1ac7c8ab0c034635Ae909d9ceefc0042 page gf-page-layout page gf-page-layout`}>
      {props["header"] || <ContentItem className="HeaderE673878b6a824da49fc302b393bb9158" parentTag={buildClassName("HeaderE673878b6a824da49fc302b393bb9158", parentTag)} subType="header_with_hero" contentSlug="polytopia-2025-handouts-header-with-hero" className="public-header-with-hero secondary-page" as="header" {...props} />}
      <main>
        {props["main-content"] || <PageContentSimplified className="MainContent60351a5d8a4048e4993f1c30e4e7cdc8" parentTag={buildClassName("MainContent60351a5d8a4048e4993f1c30e4e7cdc8", parentTag)} contentSlug="polytopia-2025-handouts-main" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="FooterA862405c0e0f4bea954dE61702a95d3d" {...props} />}
    </div>
  );
}

// id: "4b506997-61a3-412d-bcf7-5309887e3743"
// title: "Polytopia 2024 Workshops"
// type: :html
// key: "polytopia-2024-workshops"
// parent_id: nil
export function Polytopia2024Workshops4b50699761a3412dBcf75309887e3743(props: any) {
  const PageContent = AppStore.presets["PageContent"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia2024Workshops4b50699761a3412dBcf75309887e3743 page gf-page-layout page gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeaderD322727b39004ea6956f5716c320962c parentTag="Header3778a424D1544a0c88ebB19d0e49c4e6" title="Polytopia 2024 Workshops" {...props} />}
      <main>
        {props["body"] || <PageContent className="Body8e9f19ec717f4ee49a044ea8e75bf78e" parentTag={buildClassName("Body8e9f19ec717f4ee49a044ea8e75bf78e", parentTag)} {...props} />}
      </main>
      {props["footer"] || <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="Footer65e9ab419133447e900d5d9741d3e7cb" {...props} />}
    </div>
  );
}

// id: "26466f02-bb7c-4e46-ae35-f29a63c66657"
// title: ""
// type: :gf_preset
// key: "intro"
// parent_id: "8c3a11ae-70fb-4398-8569-42bcd6be18d1"
export function Intro26466f02Bb7c4e46Ae35F29a63c66657(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="Intro26466f02Bb7c4e46Ae35F29a63c66657" parentTag={buildClassName("Intro26466f02Bb7c4e46Ae35F29a63c66657", parentTag)} contentSlug="polytopia-2025-sponsors-intro" {...props} />
  );
}

// id: "9a376058-4bdb-4bb2-b8c4-cbc286a407f8"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "ec2efbf9-428e-4f18-8793-c61ac4b78538"
export const PostSlug9a3760584bdb4bb2B8c4Cbc286a407f8 = "home-page-posts2";

// id: "83c68578-7525-4f90-b6c8-b16b2b98cae5"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "f1695465-f9cb-43fb-bd34-0a8711450b63"
export function Header83c6857875254f90B6c8B16b2b98cae5(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header83c6857875254f90B6c8B16b2b98cae5" parentTag={buildClassName("Header83c6857875254f90B6c8B16b2b98cae5", parentTag)} className="public-header-with-hero secondary-page" contentSlug="polytopia-2025-workshops-header-with-hero" as="header" subType="header_with_hero" {...props} />
  );
}

// id: "7107d24b-a848-4ed3-88bb-d41f9e5e49e8"
// title: ""
// type: :gf_preset
// key: "welcome-back"
// parent_id: "01b053d6-cc6b-4446-a8d6-5d66d79a4726"
export function WelcomeBack7107d24bA8484ed388bbD41f9e5e49e8(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <WelcomeBackPopUp className="WelcomeBack7107d24bA8484ed388bbD41f9e5e49e8" parentTag={buildClassName("WelcomeBack7107d24bA8484ed388bbD41f9e5e49e8", parentTag)} {...props} />
  );
}

// id: "aa0f08e0-3462-48b8-bddb-bf7a92150f9f"
// title: "Header"
// type: :gf_preset
// key: "header"
// parent_id: "a1c5efd5-78e1-4cbb-9a6c-abc7c6676c62"
export function HeaderAa0f08e0346248b8BddbBf7a92150f9f(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="HeaderAa0f08e0346248b8BddbBf7a92150f9f" parentTag={buildClassName("HeaderAa0f08e0346248b8BddbBf7a92150f9f", parentTag)} contentSlug="polytopia-2026-presenters-header-with-hero" subType="header_with_hero" className="public-header-with-hero secondary-page" as="header" {...props} />
  );
}

// id: "b1468b7f-33b0-40cc-b623-46b3a0a0ae03"
// title: ""
// type: :reference
// key: "body"
// parent_id: "c9e3ffb4-4ecf-4540-a2cb-858ba2782ba4"
export function BodyB1468b7f33b040ccB62346b3a0a0ae03(props: any) {
  return (
    <MarketingCardsEc2efbf9428e4f188793C61ac4b78538 parentTag="BodyB1468b7f33b040ccB62346b3a0a0ae03" postSlug="polytopia-2024" {...props} />
  );
}

// id: "2a498f5e-3e6e-44cc-9ac8-bd76933c58b6"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "de7e30e6-26d6-45d9-ad10-d66fcdeadb79"
export const ContentSlug2a498f5e3e6e44cc9ac8Bd76933c58b6 = "polytopia-2026-header-with-hero";

// id: "bb7b9fa9-3403-45f6-a5d6-f603976fd0b1"
// title: ""
// type: :reference
// key: "label"
// parent_id: "4f34f9d5-d9e0-4c75-9677-ec0acd91bf48"
export function LabelBb7b9fa9340345f6A5d6F603976fd0b1(props: any) {
  return (
    <DefaultLogo22b616a278574aa58c45F16be7f9ae91 parentTag="LabelBb7b9fa9340345f6A5d6F603976fd0b1" {...props} />
  );
}

// id: "68811dea-9e2e-4b0d-b42d-335c5fcf223f"
// title: ""
// type: :text
// key: "title"
// parent_id: "7e1ec0ca-b59d-49bd-bc29-a9e6c20bc914"
export const Title68811dea9e2e4b0dB42d335c5fcf223f = "Secondary Marketing Title 2";

// id: "e55b7553-a985-48e2-9175-43641e04f541"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "c8366c9c-32d2-4d11-846a-0a250865c871"
export const ContentSlugE55b7553A98548e2917543641e04f541 = "home-page-quote";

// id: "8c3a11ae-70fb-4398-8569-42bcd6be18d1"
// title: "Polytopia 2025 Sponsors"
// type: :html
// key: "polytopia-2025-sponsors"
// parent_id: nil
export function Polytopia2025Sponsors8c3a11ae70fb4398856942bcd6be18d1(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia2025Sponsors8c3a11ae70fb4398856942bcd6be18d1 page gf-page-layout page gf-page-layout`}>
      {props["header"] || <ContentItem className="Header75aa199d900b4636941d3703ca282a4e" parentTag={buildClassName("Header75aa199d900b4636941d3703ca282a4e", parentTag)} as="header" className="public-header-with-hero secondary-page" subType="header_with_hero" contentSlug="polytopia-2025-sponsors-header-with-hero" {...props} />}
      <main>
        {props["intro"] || <ContentSnippet className="Intro26466f02Bb7c4e46Ae35F29a63c66657" parentTag={buildClassName("Intro26466f02Bb7c4e46Ae35F29a63c66657", parentTag)} contentSlug="polytopia-2025-sponsors-intro" {...props} />}
        {props["cards"] || <MarketingCards className="CardsA40ccb8f1e1748faBfa57fef9a770c87" parentTag={buildClassName("CardsA40ccb8f1e1748faBfa57fef9a770c87", parentTag)} postSlug="polytopia-2025-sponsors" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="FooterBf7d402a2ed347cdBbf951304df26899" {...props} />}
    </div>
  );
}

// id: "ce6fc325-3a29-4cab-a913-d502b20484a1"
// title: "Label"
// type: :reference
// key: "label"
// parent_id: nil
export function LabelCe6fc3253a294cabA913D502b20484a1(props: any) {
  return (
    <DefaultLogo22b616a278574aa58c45F16be7f9ae91 parentTag="LabelCe6fc3253a294cabA913D502b20484a1" {...props} />
  );
}

// id: "32fb0c3b-dcbb-4f1f-a7fa-b625395148e9"
// title: ""
// type: :text
// key: "backgroundImage"
// parent_id: "c0ec48a7-2bbf-4996-b185-b0e8f64f97cb"
export const BackgroundImage32fb0c3bDcbb4f1fA7faB625395148e9 = "https://mp1md-pub.s3.amazonaws.com/spp/images/page-background-photo.jpg";

// id: "4d0e2fbc-b14d-4752-8790-b6b9ddac6ee2"
// title: ""
// type: :text
// key: "buttonClass"
// parent_id: "ec2efbf9-428e-4f18-8793-c61ac4b78538"
export const ButtonClass4d0e2fbcB14d47528790B6b9ddac6ee2 = "inline-block px-12 py-3 hover:brightness-110 transition duration";

// id: "5db7db8a-a4fe-41ab-8dd7-1356b3e13e7d"
// title: "Footer Clone xRXtkVcbB7vf9dR Clone I9XQT7FHAZPJGAC15 Clone YBYEQWBTJ7M1RURES Clone 9QERD06Z1IRV6P2WO Clone RA2IOSI5WU9MZT94L"
// type: :reference
// key: "footer"
// parent_id: "64781529-d160-4d7e-a914-5a78296a449e"
export function Footer5db7db8aA4fe41ab8dd71356b3e13e7d(props: any) {
  return (
    <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="Footer5db7db8aA4fe41ab8dd71356b3e13e7d" {...props} />
  );
}

// id: "74ede452-646b-4403-902d-0233072c00c9"
// title: ""
// type: :gf_preset
// key: "main-content"
// parent_id: "64781529-d160-4d7e-a914-5a78296a449e"
export function MainContent74ede452646b4403902d0233072c00c9(props: any) {
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageContentSimplified className="MainContent74ede452646b4403902d0233072c00c9" parentTag={buildClassName("MainContent74ede452646b4403902d0233072c00c9", parentTag)} contentSlug="polytopia-2025-schedule-main" {...props} />
  );
}

// id: "0264b5c3-af1f-4d65-b188-6a9485730c02"
// title: ""
// type: :gf_preset
// key: "sponsors"
// parent_id: "cc27fbec-3950-4476-9c33-61b66b58ff7b"
export function Sponsors0264b5c3Af1f4d65B1886a9485730c02(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="Sponsors0264b5c3Af1f4d65B1886a9485730c02" parentTag={buildClassName("Sponsors0264b5c3Af1f4d65B1886a9485730c02", parentTag)} {...props} />
  );
}

// id: "1d83f6de-5a90-42e2-8e3a-bc74e1437ed7"
// title: ""
// type: :text
// key: "subType"
// parent_id: "de7e30e6-26d6-45d9-ad10-d66fcdeadb79"
export const SubType1d83f6de5a9042e28e3aBc74e1437ed7 = "header_with_hero";

// id: "469e36ad-1182-4d45-8d44-4c1b0a3c95d9"
// title: ""
// type: :text
// key: "subType"
// parent_id: "aa0f08e0-3462-48b8-bddb-bf7a92150f9f"
export const SubType469e36ad11824d458d444c1b0a3c95d9 = "header_with_hero";

// id: "e518e54e-3088-49a6-b775-b8064a1ee21d"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "ac342f72-8ff7-4f6a-b99a-8e91c952cd4c"
export const ContentSlugE518e54e308849a6B775B8064a1ee21d = "polytopia-2026-sponsors-intro";

// id: "c83bbdd4-3209-4cfd-ab3c-02c7edf85d3e"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "f6fe8d74-f65f-4c91-8fb5-647ca4489db6"
export const PostSlugC83bbdd432094cfdAb3c02c7edf85d3e = "footer-social-links";

// id: "49985c3b-4bbe-4262-bf44-a0895b2dd7db"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "9679a72e-6974-4fd0-816a-5a192e535f09"
export const PostSlug49985c3b4bbe4262Bf44A0895b2dd7db = "home-hero";

// id: "53d2139f-7035-49b7-9a7c-39e0e90bc458"
// title: "Members Area"
// type: :html
// key: "members-area-default"
// parent_id: nil
export function MembersAreaDefault53d2139f703549b79a7c39e0e90bc458(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MembersAreaDefault53d2139f703549b79a7c39e0e90bc458 page`}>
      {props["header"] || <MembersAreaHeader897ce2cbAcaf4349B1463421534478b4 parentTag="Header9cefac05Fa824f9c81e7F6da92cd8b7d" navMenuSlug="members-primary-nav" {...props} />}
      {props["footer"] || <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="Footer467cf53559df4392Ad776c9b62c77c9e" {...props} />}
    </div>
  );
}

// id: "cc27fbec-3950-4476-9c33-61b66b58ff7b"
// title: "Polytopia 2026 Workshops"
// type: :html
// key: "polytopia-2026-workshops"
// parent_id: nil
export function Polytopia2026WorkshopsCc27fbec395044769c3361b66b58ff7b(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia2026WorkshopsCc27fbec395044769c3361b66b58ff7b page gf-page-layout page gf-page-layout`}>
      {props["header"] || <ContentItem className="Header4a4fc60bB4a34a0dB72a6f0ebf6adeb8" parentTag={buildClassName("Header4a4fc60bB4a34a0dB72a6f0ebf6adeb8", parentTag)} as="header" contentSlug="polytopia-2026-workshops-header-with-hero" className="public-header-with-hero secondary-page" subType="header_with_hero" {...props} />}
      <main>
        {props["main-content"] || <PageContentSimplified className="MainContent62fb7053395b4237889bDb8fc7d03c35" parentTag={buildClassName("MainContent62fb7053395b4237889bDb8fc7d03c35", parentTag)} contentSlug="polytopia-2026-workshops-content" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="FooterFd20f010A85b4b958f465c1b4c8fa41c" {...props} />}
    </div>
  );
}

// id: "7e1ec0ca-b59d-49bd-bc29-a9e6c20bc914"
// title: ""
// type: :reference
// key: "hero"
// parent_id: "d322727b-3900-4ea6-956f-5716c320962c"
export function Hero7e1ec0caB59d49bdBc29A9e6c20bc914(props: any) {
  return (
    <SecondaryMarketingHero2a580a58Ae5b4c08A86eAa6b1313a1ff parentTag="Hero7e1ec0caB59d49bdBc29A9e6c20bc914" title="Secondary Marketing Title 2" {...props} />
  );
}

// id: "3778a424-d154-4a0c-88eb-b19d0e49c4e6"
// title: ""
// type: :reference
// key: "header"
// parent_id: "4b506997-61a3-412d-bcf7-5309887e3743"
export function Header3778a424D1544a0c88ebB19d0e49c4e6(props: any) {
  return (
    <SecondaryMarketingHeaderD322727b39004ea6956f5716c320962c parentTag="Header3778a424D1544a0c88ebB19d0e49c4e6" title="Polytopia 2024 Workshops" {...props} />
  );
}

// id: "07957308-ba0f-4778-839f-3a2cf03fdb83"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "431498e3-a11c-4d75-9a7b-b4c9f9cf7c75"
export function Copyright07957308Ba0f4778839f3a2cf03fdb83(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="Copyright07957308Ba0f4778839f3a2cf03fdb83" parentTag={buildClassName("Copyright07957308Ba0f4778839f3a2cf03fdb83", parentTag)} {...props} />
  );
}

// id: "affbc937-d9f9-470a-a2e4-aa62c5e847e5"
// title: ""
// type: :gf_preset
// key: "sponsors"
// parent_id: "8c3a11ae-70fb-4398-8569-42bcd6be18d1"
export function SponsorsAffbc937D9f9470aA2e4Aa62c5e847e5(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="SponsorsAffbc937D9f9470aA2e4Aa62c5e847e5" parentTag={buildClassName("SponsorsAffbc937D9f9470aA2e4Aa62c5e847e5", parentTag)} {...props} />
  );
}

// id: "43be22c4-07a6-4b4f-9c8a-9c1cad3b9c76"
// title: ""
// type: :text
// key: "className"
// parent_id: "4a4fc60b-b4a3-4a0d-b72a-6f0ebf6adeb8"
export const ClassName43be22c407a64b4f9c8a9c1cad3b9c76 = "public-header-with-hero secondary-page";

// id: "34c93d13-63e2-49cb-8c2a-440f0cbadcac"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "e17cdbc6-65c4-4412-84ad-ec551ebb4118"
export const ContentSlug34c93d1363e249cb8c2a440f0cbadcac = "polytopia-2026-schedule-main";

// id: "6e066d82-72c0-453a-8034-b86a5669ab0c"
// title: ""
// type: :text
// key: "subType"
// parent_id: "6730e02c-a933-471c-ada3-37da8e10554c"
export const SubType6e066d8272c0453a8034B86a5669ab0c = "header_with_hero";

// id: "9ebacab8-1a98-435b-8a66-1a0b20b0754a"
// title: ""
// type: :text
// key: "title"
// parent_id: "3778a424-d154-4a0c-88eb-b19d0e49c4e6"
export const Title9ebacab81a98435b8a661a0b20b0754a = "Polytopia 2024 Workshops";

// id: "5f7b669b-2597-4559-8075-198c85c2ba2a"
// title: ""
// type: :text
// key: "as"
// parent_id: "92500507-4e60-4a1f-a91c-f77b1faaca57"
export const As5f7b669b259745598075198c85c2ba2a = "header";

// id: "7baaf22f-8a94-416f-957e-d14924005b83"
// title: "Resources Page"
// type: :reference
// key: "resources-page"
// parent_id: nil
export function ResourcesPage7baaf22f8a94416f957eD14924005b83(props: any) {
  return (
    <SecondaryPageAba48207A5c34fdc96e43317026c1125 parentTag="ResourcesPage7baaf22f8a94416f957eD14924005b83" header={<SecondaryMarketingHeaderD322727b39004ea6956f5716c320962c parentTag="Header25314445A50b4b9dBf98Eeeba79428ab" title="Resources" />} {...props} />
  );
}

// id: "63e50fdb-1935-4ee0-ad40-b4d6b3bd4311"
// title: "About Us"
// type: :html
// key: "about-us-page"
// parent_id: nil
export function AboutUsPage63e50fdb19354ee0Ad40B4d6b3bd4311(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutUsPage63e50fdb19354ee0Ad40B4d6b3bd4311 page gf-page-layout page gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeaderD322727b39004ea6956f5716c320962c parentTag="Header76cf718aEc424c6197bd8f531c0c1998" title="About Us" {...props} />}
      {props["body"] || <MarketingBody3e8d1d1aCf554de8979d33d4b536ae88 parentTag="Body86af37acCc8e42a09f0a55a2670666f8" postSlug="about-us-posts" {...props} />}
      {props["footer"] || <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="FooterDfb9fcbd7e964a5bAc9456533d9a84c9" {...props} />}
    </div>
  );
}

// id: "edf6a11b-848c-4669-ae8a-52ba221e8196"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "98ce7e4a-8f24-4b36-91da-2cf0511fd380"
export function LinkedLogoEdf6a11b848c4669Ae8a52ba221e8196(props: any) {
  const Link = AppStore.presets["Link"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogoEdf6a11b848c4669Ae8a52ba221e8196" parentTag={buildClassName("LinkedLogoEdf6a11b848c4669Ae8a52ba221e8196", parentTag)} label={<DefaultLogo22b616a278574aa58c45F16be7f9ae91 parentTag="Label3387b5e1185b4c06Bdc5D931d226971b" alt="logo" />} {...props} />
  );
}

// id: "f11e8e7b-4b18-4745-aab4-a1145a2166be"
// title: ""
// type: :text
// key: "alt"
// parent_id: "22b616a2-7857-4aa5-8c45-f16be7f9ae91"
export const AltF11e8e7b4b184745Aab4A1145a2166be = "logo";

// id: "5984183c-2321-474d-8ca2-bee03d8971b2"
// title: ""
// type: :gf_preset
// key: "button"
// parent_id: "4ad1675c-4e1d-49c1-a127-a385f60f9c53"
export function Button5984183c2321474d8ca2Bee03d8971b2(props: any) {
  const Button = AppStore.presets["Button"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Button className="Button5984183c2321474d8ca2Bee03d8971b2" parentTag={buildClassName("Button5984183c2321474d8ca2Bee03d8971b2", parentTag)} href="/join" label="Join Us" {...props} />
  );
}

// id: "933a5b4f-c671-47a5-8118-640bd13d1ec7"
// title: ""
// type: :text
// key: "imageUrl"
// parent_id: "22b616a2-7857-4aa5-8c45-f16be7f9ae91"
export const ImageUrl933a5b4fC67147a58118640bd13d1ec7 = "https://mp1md-pub.s3.us-west-2.amazonaws.com/spp-logo.svg";

// id: "0343d407-90b1-4bf4-ab03-258a9c46ddaa"
// title: "Marketing Primary Navigation"
// type: :text
// key: "navMenuSlug"
// parent_id: "904a1e2b-c08c-4364-b177-914aba47206d"
export const NavMenuSlug0343d40790b14bf4Ab03258a9c46ddaa = "marketing-primary-nav";

// id: "bc257de8-b026-4926-bdac-76e363c4dbc1"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "d16ea53d-52d1-46b5-a684-252e41a4cfbc"
export const PostSlugBc257de8B0264926Bdac76e363c4dbc1 = "polytopia-2026-sponsors-cards";

// id: "da65ae2f-9033-46d7-9bce-d95bdfeca1a9"
// title: ""
// type: :text
// key: "subType"
// parent_id: "83c68578-7525-4f90-b6c8-b16b2b98cae5"
export const SubTypeDa65ae2f903346d79bceD95bdfeca1a9 = "header_with_hero";

// id: "f5dd354e-763e-4c3f-a93b-a327c935bd86"
// title: ""
// type: :text
// key: "as"
// parent_id: "9aafe6f7-00df-4917-bba6-93421ba69b4f"
export const AsF5dd354e763e4c3fA93bA327c935bd86 = "header";

// id: "3f847fdc-f47f-4758-8f3e-8733a564b685"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "86af37ac-cc8e-42a0-9f0a-55a2670666f8"
export const PostSlug3f847fdcF47f47588f3e8733a564b685 = "about-us-posts";

// id: "82f50a5e-bc40-42be-b9d0-72b72721b2d2"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "d47b2dc2-2cd9-4de8-a63a-62555e588dc0"
export const PostSlug82f50a5eBc4042beB9d072b72721b2d2 = "polytopia-2026-presenters-cards";

// id: "2394baa1-cb1e-48d3-ab02-c8c97332f98c"
// title: "Polytopia 2026"
// type: :html
// key: "polytopia-2026"
// parent_id: nil
export function Polytopia20262394baa1Cb1e48d3Ab02C8c97332f98c(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia20262394baa1Cb1e48d3Ab02C8c97332f98c page gf-page-layout page gf-page-layout`}>
      {props["header"] || <ContentItem className="HeaderDe7e30e626d645d9Ad10D66fcdeadb79" parentTag={buildClassName("HeaderDe7e30e626d645d9Ad10D66fcdeadb79", parentTag)} as="header" contentSlug="polytopia-2026-header-with-hero" subType="header_with_hero" className="public-header-with-hero secondary-page" {...props} />}
      <main>
        {props["cards"] || <MarketingCards className="Cards05732d952d1347648335E543c068dc94" parentTag={buildClassName("Cards05732d952d1347648335E543c068dc94", parentTag)} postSlug="polytopia-2026-cards" {...props} />}
        {props["sponsors"] || <ContentSnippet className="Sponsors5fb41566Cf34457e93cf5bf05232c71d" parentTag={buildClassName("Sponsors5fb41566Cf34457e93cf5bf05232c71d", parentTag)} contentSlug="polytopia-2026-sponsors" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="Footer5e5f23fdE5694f24B094297999e634fe" {...props} />}
    </div>
  );
}

// id: "42920e22-1395-41f7-8b11-cfccafea062d"
// title: "Admin Pages"
// type: :html
// key: "admin-pages"
// parent_id: nil
export function AdminPages42920e22139541f78b11Cfccafea062d(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AdminPages42920e22139541f78b11Cfccafea062d`}>
      {props.children}
    </div>
  );
}

// id: "4f34f9d5-d9e0-4c75-9677-ec0acd91bf48"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "b5b2de7c-36d9-4c73-9f44-306fa937c712"
export function LinkedLogo4f34f9d5D9e04c759677Ec0acd91bf48(props: any) {
  const Link = AppStore.presets["Link"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogo4f34f9d5D9e04c759677Ec0acd91bf48" parentTag={buildClassName("LinkedLogo4f34f9d5D9e04c759677Ec0acd91bf48", parentTag)} className="linked-logo" url="/" label={<DefaultLogo22b616a278574aa58c45F16be7f9ae91 parentTag="LabelBb7b9fa9340345f6A5d6F603976fd0b1" alt="logo" />} {...props} />
  );
}

// id: "95222ead-a93a-4b2c-863a-e810c0213235"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "9145ee07-08c5-4380-adb3-483f1a835655"
export function Footer95222eadA93a4b2c863aE810c0213235(props: any) {
  return (
    <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="Footer95222eadA93a4b2c863aE810c0213235" {...props} />
  );
}

// id: "dfb9fcbd-7e96-4a5b-ac94-56533d9a84c9"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "63e50fdb-1935-4ee0-ad40-b4d6b3bd4311"
export function FooterDfb9fcbd7e964a5bAc9456533d9a84c9(props: any) {
  return (
    <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="FooterDfb9fcbd7e964a5bAc9456533d9a84c9" {...props} />
  );
}

// id: "78400dd8-8d28-4c6b-b15c-32fb36211fa1"
// title: ""
// type: :reference
// key: "header"
// parent_id: "b7f57dea-85d9-4fcb-a380-8e0616076d1a"
export function Header78400dd88d284c6bB15c32fb36211fa1(props: any) {
  return (
    <SecondaryMarketingHeaderD322727b39004ea6956f5716c320962c parentTag="Header78400dd88d284c6bB15c32fb36211fa1" title="Leveling" {...props} />
  );
}

// id: "c0a26015-b445-4f41-9319-d08beb5d99b0"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "e8860531-bb88-4c11-a491-7dd232f7a31d"
export const PostSlugC0a26015B4454f419319D08beb5d99b0 = "polytopia-2025-presenters-cards";

// id: "555222ae-184b-4f5c-aad8-731ea2384abf"
// title: ""
// type: :text
// key: "className"
// parent_id: "aa0f08e0-3462-48b8-bddb-bf7a92150f9f"
export const ClassName555222ae184b4f5cAad8731ea2384abf = "public-header-with-hero secondary-page";

// id: "2617d9bb-205d-4960-942c-1148c1dad3ad"
// title: ""
// type: :text
// key: "title"
// parent_id: "71294788-60db-4acf-8ce1-5d1c09e88ad8"
export const Title2617d9bb205d4960942c1148c1dad3ad = "Secondary Page";

// id: "c43819a3-e21c-4f2e-a0d2-45d0709e485e"
// title: ""
// type: :text
// key: "className"
// parent_id: "de7e30e6-26d6-45d9-ad10-d66fcdeadb79"
export const ClassNameC43819a3E21c4f2eA0d245d0709e485e = "public-header-with-hero secondary-page";

// id: "3908d6b2-1d25-46f6-a831-1708917b7a92"
// title: "Polytopia 2025"
// type: :html
// key: "polytopia-2025"
// parent_id: nil
export function Polytopia20253908d6b21d2546f6A8311708917b7a92(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia20253908d6b21d2546f6A8311708917b7a92 page gf-page-layout page gf-page-layout`}>
      {props["header"] || <ContentItem className="Header6730e02cA933471cAda337da8e10554c" parentTag={buildClassName("Header6730e02cA933471cAda337da8e10554c", parentTag)} title="Polytopia 2025" contentSlug="polytopia-2025-header-with-hero" className="public-header-with-hero secondary-page" as="header" subType="header_with_hero" {...props} />}
      <main>
        {props["cards"] || <MarketingCards className="Cards51c25f57A5804388Ab198ddf316b636e" parentTag={buildClassName("Cards51c25f57A5804388Ab198ddf316b636e", parentTag)} postSlug="polytopia-2025" {...props} />}
        {props["sponsors"] || <ContentSnippet className="Sponsors17d374370c9749aa924077f93b574aee" parentTag={buildClassName("Sponsors17d374370c9749aa924077f93b574aee", parentTag)} contentSlug="polytopia-page-sponsors" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="Footer1e37ae2bD76c4a3a920fB9cfa84249bc" {...props} />}
    </div>
  );
}

// id: "66b3d74d-5000-4992-87bf-050a85ad6cca"
// title: "Join Us Page"
// type: :reference
// key: "join-us-page"
// parent_id: nil
export function JoinUsPage66b3d74d5000499287bf050a85ad6cca(props: any) {
  return (
    <SecondaryPageAba48207A5c34fdc96e43317026c1125 parentTag="JoinUsPage66b3d74d5000499287bf050a85ad6cca" header={<SecondaryMarketingHeaderD322727b39004ea6956f5716c320962c parentTag="Header34d9530557bf4775A8f23a3789f0732a" title="Join Us" />} {...props} />
  );
}

// id: "dc18476c-e916-4ba1-9866-3b407d07fa0f"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "aba48207-a5c3-4fdc-96e4-3317026c1125"
export function FooterDc18476cE9164ba198663b407d07fa0f(props: any) {
  return (
    <DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75 parentTag="FooterDc18476cE9164ba198663b407d07fa0f" {...props} />
  );
}

// id: "86af37ac-cc8e-42a0-9f0a-55a2670666f8"
// title: ""
// type: :reference
// key: "body"
// parent_id: "63e50fdb-1935-4ee0-ad40-b4d6b3bd4311"
export function Body86af37acCc8e42a09f0a55a2670666f8(props: any) {
  return (
    <MarketingBody3e8d1d1aCf554de8979d33d4b536ae88 parentTag="Body86af37acCc8e42a09f0a55a2670666f8" postSlug="about-us-posts" {...props} />
  );
}

// id: "eeb8a88a-607b-4533-8ef1-6f03f46226bb"
// title: ""
// type: :gf_preset
// key: "sponsors"
// parent_id: "a1c5efd5-78e1-4cbb-9a6c-abc7c6676c62"
export function SponsorsEeb8a88a607b45338ef16f03f46226bb(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="SponsorsEeb8a88a607b45338ef16f03f46226bb" parentTag={buildClassName("SponsorsEeb8a88a607b45338ef16f03f46226bb", parentTag)} {...props} />
  );
}

// id: "71294788-60db-4acf-8ce1-5d1c09e88ad8"
// title: ""
// type: :reference
// key: "header"
// parent_id: "aba48207-a5c3-4fdc-96e4-3317026c1125"
export function Header7129478860db4acf8ce15d1c09e88ad8(props: any) {
  return (
    <SecondaryMarketingHeaderD322727b39004ea6956f5716c320962c parentTag="Header7129478860db4acf8ce15d1c09e88ad8" title="Secondary Page" {...props} />
  );
}

// id: "89f653e9-4d45-4dcc-893b-fdb19b5ee8c2"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "d322727b-3900-4ea6-956f-5716c320962c"
export function HeaderTop89f653e94d454dcc893bFdb19b5ee8c2(props: any) {
  return (
    <DefaultHeaderTopB5b2de7c36d94c739f44306fa937c712 parentTag="HeaderTop89f653e94d454dcc893bFdb19b5ee8c2" {...props} />
  );
}

// id: "1cb620b8-e059-4d9a-a6ac-f39250696ba5"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "4b8343b6-b273-4bd1-b916-9407681e74bb"
export const ContentSlug1cb620b8E0594d9aA6acF39250696ba5 = "polytopia-2026-handouts-main";

// id: "ef0a4343-8c0a-4d3e-95c5-1b351dc2ae28"
// title: ""
// type: :text
// key: "className"
// parent_id: "4f87b07d-15f5-443c-88f9-ca828939ffbd"
export const ClassNameEf0a43438c0a4d3e95c51b351dc2ae28 = "public-header-with-hero secondary-page";

// id: "4a6f2c00-56e0-4cf0-b1f4-55557238b2cf"
// title: ""
// type: :text
// key: "label"
// parent_id: "5984183c-2321-474d-8ca2-bee03d8971b2"
export const Label4a6f2c0056e04cf0B1f455557238b2cf = "Join Us";

// id: "bc27e552-5ee6-42d7-a7cb-0513bd830b60"
// title: ""
// type: :text
// key: "as"
// parent_id: "aa0f08e0-3462-48b8-bddb-bf7a92150f9f"
export const AsBc27e5525ee642d7A7cb0513bd830b60 = "header";

// id: "7c66cd4f-7249-48be-a378-01924ae3a934"
// title: ""
// type: :text
// key: "className"
// parent_id: "db3480c8-2b18-4a72-a971-53bc1e0e6dbc"
export const ClassName7c66cd4f724948beA37801924ae3a934 = "public-header-with-hero secondary-page";

// id: "c7d36508-16e1-4dbc-b1cf-d95fb1b531c8"
// title: ""
// type: :text
// key: "className"
// parent_id: "9aafe6f7-00df-4917-bba6-93421ba69b4f"
export const ClassNameC7d3650816e14dbcB1cfD95fb1b531c8 = "public-header-with-hero secondary-page";

// id: "1450ec6c-d004-4dad-83c2-39bbead54679"
// title: ""
// type: :text
// key: "subType"
// parent_id: "fba5956a-be28-463d-b0b2-9af03b3977c3"
export const SubType1450ec6cD0044dad83c239bbead54679 = "header_with_hero";

// id: "bdde1066-82f0-44b9-8f10-2c332ee35681"
// title: ""
// type: :text
// key: "subType"
// parent_id: "4a4fc60b-b4a3-4a0d-b72a-6f0ebf6adeb8"
export const SubTypeBdde106682f044b98f102c332ee35681 = "header_with_hero";

// id: "bf52de6e-7c34-4ac7-bb3e-81a1017af7a2"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "fba5956a-be28-463d-b0b2-9af03b3977c3"
export const ContentSlugBf52de6e7c344ac7Bb3e81a1017af7a2 = "polytopia-2025-sponsors-header-with-hero";

const Components = {
  Polytopia2025Presenters4072249eBada40ffBa9e64dab281acbc,
  Polytopia2024C9e3ffb44ecf4540A2cb858ba2782ba4,
  Polytopia2026Sponsors7ee34b5458724ca79dba3aecfdd5e711,
  MarketingCards422edffb989f4c3382c7F6696a97485e,
  SocialLinksF6fe8d74F65f4c918fb5647ca4489db6,
  FooterFd7c4072D8dd4f3bA0cc3c69d210a332,
  HeaderTopE37101d1725f44f18ab88c6d18d413f0,
  Header1535227388af40c0B1846eff6debaf9b,
  ContentSlugB8d6d8f81d31410c9c702159a72b26a7,
  ContentSlug73f01a4e715242d3Be15C95068c476e5,
  NavMenuSlug6e174bb65bb64bfa9b00B813513d272c,
  AsDea14d619dba4df288c3362ce5228ed2,
  As3fdce8c83e274d1e96886c49c59e3fd8,
  Header0778c5034dd8405aAe8aB3a43795e736,
  HomeHeaderC0ec48a72bbf4996B185B0e8f64f97cb,
  PageQuoteB316e28eCae645b397817b1775114d9e,
  Sponsors5fb41566Cf34457e93cf5bf05232c71d,
  Cards05732d952d1347648335E543c068dc94,
  HeaderFba5956aBe28463dB0b29af03b3977c3,
  Sponsors80cd575d5a52415c8bc896422cda80f6,
  BackgroundImage260af35330194597A742693edbb1568b,
  AsB086f85f751a43f291828426b89806bc,
  ClassName0002a45961454110B87438ae66d623ac,
  ContentSlug2492ae597ccd4232A9ea8bfdcb65db85,
  SubType88e3fe84Ba74432aA03a4ce7016d24e7,
  ContentSlugB8c7e56413c74d1b942d34844512af78,
  Polytopia2025WorkshopsF1695465F9cb43fbBd340a8711450b63,
  MessagePages8d91547622b745e1941d6e130611248d,
  TitleD8882c31Fe234687A4694b937d8f0f1d,
  FooterD3d5470662204367A24275c2d034aa53,
  MainContent4b8343b6B2734bd1B9169407681e74bb,
  MainContent231083a591cc4c388d31B416c279df65,
  CardsD47b2dc22cd94de8A63a62555e588dc0,
  Header6730e02cA933471cAda337da8e10554c,
  As597a7f6e07f94494817666617be36482,
  PostSlugD3b893b73d4948c8AbecEb5e7d17e14c,
  ContentSlug4f3d71456f0447adBe93111574ee9c43,
  SubType8c1822f252c24ea994cdFc07f33e8439,
  ClassC5fe79feA7bb4c5f9bf871c87a2d0092,
  MembersAreaHeader897ce2cbAcaf4349B1463421534478b4,
  Polytopia2026PresentersA1c5efd578e14cbb9a6cAbc7c6676c62,
  DefaultFooter431498e3A11c4d759a7bB4c9f9cf7c75,
  MainContent62fb7053395b4237889bDb8fc7d03c35,
  FooterEaec2e20589a45afAbd8F0daa9d67c56,
  Header9aafe6f700df4917Bba693421ba69b4f,
  MainContentE17cdbc665c4441284adEc551ebb4118,
  HeaderE673878b6a824da49fc302b393bb9158,
  ContentSlugFe392684170346c082aeA410b62af7b6,
  Title7ee487c2B181432aB1d99dd6a3a3683e,
  Title46e4e6c98ee040ff97830e436386d363,
  SubType3a350b6cB4354f6dBcf09843dafe728b,
  PostSlug2f741eb2606b4cbaA7d5D5bca8539f07,
  SecondaryMarketingHeaderD322727b39004ea6956f5716c320962c,
  Polytopia2025Schedule64781529D1604d7eA9145a78296a449e,
  MainContent60351a5d8a4048e4993f1c30e4e7cdc8,
  Intro7a7f29c6Eef74734Add6Bf3f38e05bb4,
  Footer2046e99e13574c8dA26d65ac045077c2,
  HeaderB746f40bAc47431f982194a21f80ed31,
  SponsorsC70c6d7e203044e596a30532c26798f1,
  IntroCb7df874039043e898bc667dba362100,
  ContentSlugE33f67471f5d4bb388aeFc0205a030b8,
  Title50edf15dA00f4e658df75d81925b338b,
  Title0feddc69Aa1140379752E38f695a9099,
  ContentSlugCc2512a7Ccd245bcB15806931ba544f8,
  Class4f9800938d164f5bBc2dF264992c9d6d,
  SignupPagesE9cede63Cd1f4ab388e718a811b72970,
  AboutLevelingPageB7f57dea85d94fcbA3808e0616076d1a,
  Sponsors320bd74bF1fa4ee685531780be90146d,
  Header75aa199d900b4636941d3703ca282a4e,
  Sponsors7270b3503b9248c9A237B2f720303d0e,
  Header6c19d6800f0b4753B047B5e66481f1a5,
  Sponsors17d374370c9749aa924077f93b574aee,
  FooterFd20f010A85b4b958f465c1b4c8fa41c,
  ContentSlug15b9057d0a444882Be54C8620d2cbb2d,
  TitleA1dee271A2a047259f66512040262295,
  PostSlug10697249E96e4602B584Eb07a0ed58c4,
  ContentSlugC847a337Cc12489181efB39eed04dbeb,
  ClassNameFd5ce6757b304b31893cEfdda5be33c3,
  DefaultHeader904a1e2bC08c4364B177914aba47206d,
  PublicEventsPage9145ee0708c54380Adb3483f1a835655,
  Header4a4fc60bB4a34a0dB72a6f0ebf6adeb8,
  Hero9679a72e69744fd0816a5a192e535f09,
  Body8e9f19ec717f4ee49a044ea8e75bf78e,
  Cards51c25f57A5804388Ab198ddf316b636e,
  Footer7ffb809a7101464c824a154022dddf77,
  CardsE8860531Bb884c11A4917dd232f7a31d,
  As026261d5F1174c58B004045578077b95,
  ContentSlugA843ac81Bd9b48168046007b2623c8bb,
  ContentSlugD275c68bD3bf43daB0e73231c3d7196c,
  ContentSlugF127a780916b4e018a5c17959a326bb7,
  ClassName05855138D00f4b40B0592f559d8d9e99,
  MarketingCardsEc2efbf9428e4f188793C61ac4b78538,
  Polytopia2026HandoutsDf950adf456f480597ba0f1198c81e87,
  HeaderDb3480c82b184a72A97153bc1e0e6dbc,
  Header76245fd58d1746feBea752add2f81116,
  Footer65e9ab419133447e900d5d9741d3e7cb,
  Header25314445A50b4b9dBf98Eeeba79428ab,
  Header76cf718aEc424c6197bd8f531c0c1998,
  FooterBf7d402a2ed347cdBbf951304df26899,
  ClassName42214633Fbd945daBf72C8b0a7f568d9,
  ClassName695f806cBd2e45f1921cD515bf905488,
  DefaultLogo22b616a278574aa58c45F16be7f9ae91,
  SecondaryPageAba48207A5c34fdc96e43317026c1125,
  CardsA40ccb8f1e1748faBfa57fef9a770c87,
  Links465a3355F94847c48642Cc65fe8ce945,
  HeaderTopFd1f85b6Eb5f4f9aA5f6B50feee66ee1,
  Footer8e896507806f48ac82b4910bba017cdb,
  Title5f229a49B41f4fdfAe949a465af09b6b,
  TitleFf3b1a5eA98c4b45A8116c996f32446e,
  TitleB0f3a0c2C2cf4a9fB597930f1299c07e,
  ClassName88e2d98d12e1418f8417Da0459390cf7,
  PostSlug2995b81f04e6472aBd58F5a209ab232e,
  As7b49573f79cd4433B8487b287f68b17f,
  As5744323049864090B800F0eb1f22d2ea,
  Footer7085f7ccB27742719297C9aae5c94dc1,
  MemberPages301b0b8280304324A772E738b349e1b2,
  Footer1e37ae2bD76c4a3a920fB9cfa84249bc,
  Body5e9c485d1d3f4df6810c2ac6e28b9128,
  HeaderE5ec72f39a1e40e291bbA7e769639fb1,
  Groupflow082a3554B4d74a31B87aAf8490a5ae71,
  Footer467cf53559df4392Ad776c9b62c77c9e,
  Footer5c039683Ceb3423eB671A4f6e2bce508,
  Url0a358c62C1854d88986e1d4122157f91,
  ClassName102f6f8d53444209A556Ea69ef1bb107,
  Title6dbd78f253a6475b806366299a178059,
  SubType6f437bde1dc74529Aaf9362381893b70,
  ContentSlug911b562e4f41439fAd526089b7535d8e,
  HrefA370469aF19c4ff2B7cc592b39e67e7a,
  SecondaryMarketingHero2a580a58Ae5b4c08A86eAa6b1313a1ff,
  Footer5e5f23fdE5694f24B094297999e634fe,
  Title2b394248560f4ba6864cDe16b2fb7504,
  QuoteC8366c9c32d24d11846a0a250865c871,
  Footer6926554bFf714fa7A4000e350f433c1b,
  Header34d9530557bf4775A8f23a3789f0732a,
  Logo34f631c1Cd42400dB02e98789a562436,
  NavMenuSlugC9977de5Faa34895B9f9829989726b38,
  ContentSlugDc9df452650b46f3B77e5c5cceca3b03,
  Label3387b5e1185b4c06Bdc5D931d226971b,
  ContentSlug68e4bfc4B8534f758748Dbb742846763,
  ContentSlug42764855Cade4ae09ee1Aba3301a6d6d,
  HomePageHero4ad1675c4e1d49c1A127A385f60f9c53,
  HomePage01b053d6Cc6b4446A8d65d66d79a4726,
  Header925005074e604a1fA91cF77b1faaca57,
  SecondaryNav8825200368a94a94Bfa2Fe799adbf5f7,
  HeaderDe7e30e626d645d9Ad10D66fcdeadb79,
  Header4f87b07d15f5443c88f9Ca828939ffbd,
  Navigation810aebb7D028434893bfAebf4f399b2b,
  Footer39ef6466A05a47579d9eD4ae7d92e7ab,
  ContentSlugE2459b1bEc774e7aAae49d8639cd248a,
  Title2b37737aD25a4d5bA0c5288d6abb6a5c,
  As279fce13Ecc745deA54bAc8f530ac03a,
  NavMenuSlugC6a2d947D7014ab9Aab491e2f2cea07a,
  DefaultHeaderTopB5b2de7c36d94c739f44306fa937c712,
  Polytopia2026Schedule08dd2a7c03af4d94B901Fbe2d2af471a,
  Sponsors6fd5534800ee4813Ab7cC1822e21bb36,
  Header9cefac05Fa824f9c81e7F6da92cd8b7d,
  SponsorsEa72806d924942618817E93c705387a2,
  IntroAc342f728ff74f6aB99a8e91c952cd4c,
  FooterA862405c0e0f4bea954dE61702a95d3d,
  Header8c9903d297f343a5A727B422ac9ffcae,
  ClassName3df6d10760af43a189c2Ac719ffe123e,
  HrefA7fa7e350eec452bB738D7e208982f2e,
  NavMenuSlug3b1f6f0723234bde85569e807afdd832,
  NavMenuSlug51385c487598490f9f5d36aaf268dda1,
  ShortHeader98ce7e4a8f244b3691da2cf0511fd380,
  MarketingBody3e8d1d1aCf554de8979d33d4b536ae88,
  Sponsors51cf605eF96b420b9616A59f1ae194b0,
  Navigation326b96d8B8384e9e9300F8e5f7e44234,
  CardsD16ea53d52d146b5A684252e41a4cfbc,
  FooterA34c7552D66b4944914dDe47e744e4ec,
  PostSlug04ea1bcfCc3a4ffa8fc00ca7f9bc4f27,
  SubTypeAb3ea133F57848859f0aF62794f3af6a,
  ContentSlugCa723d2eD1ed4e2b8e59E8ce6b3b5d75,
  SubType41b0417b5aa64fa280a346d35528d9bb,
  As99749698F12b404aA17aAfb48fd2583e,
  Polytopia2025Handouts1ac7c8ab0c034635Ae909d9ceefc0042,
  Polytopia2024Workshops4b50699761a3412dBcf75309887e3743,
  Intro26466f02Bb7c4e46Ae35F29a63c66657,
  PostSlug9a3760584bdb4bb2B8c4Cbc286a407f8,
  Header83c6857875254f90B6c8B16b2b98cae5,
  WelcomeBack7107d24bA8484ed388bbD41f9e5e49e8,
  HeaderAa0f08e0346248b8BddbBf7a92150f9f,
  BodyB1468b7f33b040ccB62346b3a0a0ae03,
  ContentSlug2a498f5e3e6e44cc9ac8Bd76933c58b6,
  LabelBb7b9fa9340345f6A5d6F603976fd0b1,
  Title68811dea9e2e4b0dB42d335c5fcf223f,
  ContentSlugE55b7553A98548e2917543641e04f541,
  Polytopia2025Sponsors8c3a11ae70fb4398856942bcd6be18d1,
  LabelCe6fc3253a294cabA913D502b20484a1,
  BackgroundImage32fb0c3bDcbb4f1fA7faB625395148e9,
  ButtonClass4d0e2fbcB14d47528790B6b9ddac6ee2,
  Footer5db7db8aA4fe41ab8dd71356b3e13e7d,
  MainContent74ede452646b4403902d0233072c00c9,
  Sponsors0264b5c3Af1f4d65B1886a9485730c02,
  SubType1d83f6de5a9042e28e3aBc74e1437ed7,
  SubType469e36ad11824d458d444c1b0a3c95d9,
  ContentSlugE518e54e308849a6B775B8064a1ee21d,
  PostSlugC83bbdd432094cfdAb3c02c7edf85d3e,
  PostSlug49985c3b4bbe4262Bf44A0895b2dd7db,
  MembersAreaDefault53d2139f703549b79a7c39e0e90bc458,
  Polytopia2026WorkshopsCc27fbec395044769c3361b66b58ff7b,
  Hero7e1ec0caB59d49bdBc29A9e6c20bc914,
  Header3778a424D1544a0c88ebB19d0e49c4e6,
  Copyright07957308Ba0f4778839f3a2cf03fdb83,
  SponsorsAffbc937D9f9470aA2e4Aa62c5e847e5,
  ClassName43be22c407a64b4f9c8a9c1cad3b9c76,
  ContentSlug34c93d1363e249cb8c2a440f0cbadcac,
  SubType6e066d8272c0453a8034B86a5669ab0c,
  Title9ebacab81a98435b8a661a0b20b0754a,
  As5f7b669b259745598075198c85c2ba2a,
  ResourcesPage7baaf22f8a94416f957eD14924005b83,
  AboutUsPage63e50fdb19354ee0Ad40B4d6b3bd4311,
  LinkedLogoEdf6a11b848c4669Ae8a52ba221e8196,
  AltF11e8e7b4b184745Aab4A1145a2166be,
  Button5984183c2321474d8ca2Bee03d8971b2,
  ImageUrl933a5b4fC67147a58118640bd13d1ec7,
  NavMenuSlug0343d40790b14bf4Ab03258a9c46ddaa,
  PostSlugBc257de8B0264926Bdac76e363c4dbc1,
  SubTypeDa65ae2f903346d79bceD95bdfeca1a9,
  AsF5dd354e763e4c3fA93bA327c935bd86,
  PostSlug3f847fdcF47f47588f3e8733a564b685,
  PostSlug82f50a5eBc4042beB9d072b72721b2d2,
  Polytopia20262394baa1Cb1e48d3Ab02C8c97332f98c,
  AdminPages42920e22139541f78b11Cfccafea062d,
  LinkedLogo4f34f9d5D9e04c759677Ec0acd91bf48,
  Footer95222eadA93a4b2c863aE810c0213235,
  FooterDfb9fcbd7e964a5bAc9456533d9a84c9,
  Header78400dd88d284c6bB15c32fb36211fa1,
  PostSlugC0a26015B4454f419319D08beb5d99b0,
  ClassName555222ae184b4f5cAad8731ea2384abf,
  Title2617d9bb205d4960942c1148c1dad3ad,
  ClassNameC43819a3E21c4f2eA0d245d0709e485e,
  Polytopia20253908d6b21d2546f6A8311708917b7a92,
  JoinUsPage66b3d74d5000499287bf050a85ad6cca,
  FooterDc18476cE9164ba198663b407d07fa0f,
  Body86af37acCc8e42a09f0a55a2670666f8,
  SponsorsEeb8a88a607b45338ef16f03f46226bb,
  Header7129478860db4acf8ce15d1c09e88ad8,
  HeaderTop89f653e94d454dcc893bFdb19b5ee8c2,
  ContentSlug1cb620b8E0594d9aA6acF39250696ba5,
  ClassNameEf0a43438c0a4d3e95c51b351dc2ae28,
  Label4a6f2c0056e04cf0B1f455557238b2cf,
  AsBc27e5525ee642d7A7cb0513bd830b60,
  ClassName7c66cd4f724948beA37801924ae3a934,
  ClassNameC7d3650816e14dbcB1cfD95fb1b531c8,
  SubType1450ec6cD0044dad83c239bbead54679,
  SubTypeBdde106682f044b98f102c332ee35681,
  ContentSlugBf52de6e7c344ac7Bb3e81a1017af7a2
}

export default Components;